<template>
    <v-container>
        <v-alert v-if="searchError" type="error" text dense>{{ searchError }}</v-alert>
        <v-alert v-if="savedSearch.error" type="error" text dense>{{ savedSearch.error }}</v-alert>
        <v-progress-linear v-if="savedSearch.loading" indeterminate color="primary" class="mb-3" />
        <v-row v-if="$moment().diff($moment(user.accessTill), 'minutes') > 0 || (user.resumeBasicLimit < 1 && user.resumeExtraLimit < 1) || user.accessSchedule !== 'allow'">
            <v-card width="100%">
                <v-card-text class="error white--text text-center">
                    <div v-if="$moment().diff($moment(user.accessTill), 'minutes') > 0 || (user.resumeBasicLimit < 1 && user.resumeExtraLimit < 1)">
                        Ваш доступ заблокирован.
                    </div>
                    <div v-else>
                        Доступ возможен в рабочее время
                    </div>
                    <div>Вы можете работать только с сохраненными резюме</div>
                </v-card-text>
            </v-card>
        </v-row>
        <v-row v-if="warning">
            <v-card width="100%">
                <v-card-text class="error white--text text-center">
                    Использование ссылок в форме поиска запрещено. Повторный ввод приведет к блокировке учетных записей вашей компании.
                </v-card-text>
            </v-card>
        </v-row>
        <v-row v-if="$moment(user.accessTill).diff($moment(), 'minutes') > 0 && (user.resumeBasicLimit > 0 || user.resumeExtraLimit > 0) && user.accessSchedule === 'allow'" text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Поиск</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="hide = !hide"
                        >
                            Расширенный поиск
                        </v-btn>
                    </v-toolbar>
                    <v-card-text
                        v-if="!hide"
                    >
                        <v-form
                            @submit.prevent="submitSearch"
                            autocomplete="off"
                        >
                            <v-card-text>
                                <v-row align="center">
                                    <v-col>
                                        <v-combobox
                                            v-model="data.query1"
                                            :loading="autocomplete1.loading"
                                            :items="autocomplete1.items"
                                            :search-input.sync="autocomplete1.search"
                                            :error-messages="errors.query1"
                                            cache-items
                                            label="Поиск по резюме"
                                            hide-no-data
                                            hide-details
                                            class="mb-0"
                                        />
                                    </v-col>
                                    <v-col cols="auto">
                                        <favorite-search-button @click="openSaveSearch" :disabled="progress || savedSearch.loading" />
                                        <v-btn
                                            :disabled="progress || savedSearch.loading"
                                            type="submit"
                                            color="primary"
                                        >
                                            Найти
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <div>
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs,  }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="grey--text custom-transform-class text-none mb-3 ma-0 pa-0 mr-5"
                                                dark
                                                text
                                            >
                                                <v-icon>mdi-menu-down</v-icon>
                                                <span v-if="data.query1_logic === 'all'">Все слова</span>
                                                <span v-if="data.query1_logic === 'any'">Любое из слов</span>
                                                <span v-if="data.query1_logic === 'phrase'">Точная фраза</span>
                                                <span v-if="data.query1_logic === 'except'">Не встречаются</span>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text class="pa-0">
                                                <v-list class="ma-0 pa-0">
                                                    <v-list-item-group
                                                        v-model="data.query1_logic"
                                                    >
                                                        <v-list-item value="all">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Все слова</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item value="any">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Любое из слов</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item value="phrase">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Точная фраза</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item value="except">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Не встречаются</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list-item-group>
                                                </v-list>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs,  }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="grey--text custom-transform-class text-none mb-3 ma-0 pa-0"
                                                dark
                                                text
                                            >
                                                <v-icon>mdi-menu-down</v-icon>
                                                <span v-if="data.query1_fields.length === 1 && data.query1_fields[0] === 'everywhere'">Везде</span>
                                                <span v-if="data.query1_fields.length === 1 && data.query1_fields[0] === 'title'">В названии резюме</span>
                                                <span v-if="data.query1_fields.length === 1 && data.query1_fields[0] === 'education'">В образовании</span>
                                                <span v-if="data.query1_fields.length === 1 && data.query1_fields[0] === 'skills'">В ключевых навыках</span>
                                                <span v-if="data.query1_fields.length === 1 && data.query1_fields[0] === 'experience'">В опыте работы</span>
                                                <span v-if="data.query1_fields.length === 1 && data.query1_fields[0] === 'experience_company'">В компаниях и отраслях</span>
                                                <span v-if="data.query1_fields.length === 1 && data.query1_fields[0] === 'experience_position'">В должностях</span>
                                                <span v-if="data.query1_fields.length === 1 && data.query1_fields[0] === 'experience_description'">В обязанностях</span>
                                                <span v-if="data.query1_fields.length > 1">В {{ data.query1_fields.length }} разделах резюме</span>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <v-treeview
                                                    v-model="data.query1_fields"
                                                    :items="query_fields"
                                                    selectable
                                                    activatable
                                                    open-all
                                                ></v-treeview>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                                <v-btn
                                    v-if="queries === 1"
                                    @click="queries++"
                                    small
                                    right
                                    text
                                    color="primary"
                                    class="mb-3"
                                >
                                    Добавить ещё поле
                                </v-btn>
                                <v-row v-if="queries > 1">
                                    <v-col xs="10" md="10">
                                        <v-combobox
                                            v-if="queries > 1"
                                            v-model="data.query2"
                                            :loading="autocomplete2.loading"
                                            :items="autocomplete2.items"
                                            :search-input.sync="autocomplete2.search"
                                            :error-messages="errors.query2"
                                            cache-items
                                            label="Поиск по резюме"
                                            hide-no-data
                                            hide-details
                                            class="mb-0"
                                        />
                                    </v-col>
                                    <v-col xs="2" md="2">
                                        <v-btn
                                            v-if="queries === 2"
                                            @click="data.query2 = ''; data.query2_logic = 'all'; data.query2_fields = ['everywhere']; queries--"
                                            x-small
                                            right
                                            fab
                                            icon
                                            class="mt-4"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <div v-if="queries > 1">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs,  }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="grey--text custom-transform-class text-none mb-3 ma-0 pa-0 mr-5"
                                                dark
                                                text
                                            >
                                                <v-icon>mdi-menu-down</v-icon>
                                                <span v-if="data.query2_logic === 'all'">Все слова</span>
                                                <span v-if="data.query2_logic === 'any'">Любое из слов</span>
                                                <span v-if="data.query2_logic === 'phrase'">Точная фраза</span>
                                                <span v-if="data.query2_logic === 'except'">Не встречаются</span>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text class="pa-0">
                                                <v-list class="ma-0 pa-0">
                                                    <v-list-item-group
                                                        v-model="data.query2_logic"
                                                    >
                                                        <v-list-item value="all">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Все слова</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item value="any">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Любое из слов</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item value="phrase">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Точная фраза</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item value="except">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Не встречаются</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list-item-group>
                                                </v-list>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs,  }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="grey--text custom-transform-class text-none mb-3 ma-0 pa-0"
                                                dark
                                                text
                                            >
                                                <v-icon>mdi-menu-down</v-icon>
                                                <span v-if="data.query2_fields.length === 1 && data.query2_fields[0] === 'everywhere'">Везде</span>
                                                <span v-if="data.query2_fields.length === 1 && data.query2_fields[0] === 'title'">В названии резюме</span>
                                                <span v-if="data.query2_fields.length === 1 && data.query2_fields[0] === 'education'">В образовании</span>
                                                <span v-if="data.query2_fields.length === 1 && data.query2_fields[0] === 'skills'">В ключевых навыках</span>
                                                <span v-if="data.query2_fields.length === 1 && data.query2_fields[0] === 'experience'">В опыте работы</span>
                                                <span v-if="data.query2_fields.length === 1 && data.query2_fields[0] === 'experience_company'">В компаниях и отраслях</span>
                                                <span v-if="data.query2_fields.length === 1 && data.query2_fields[0] === 'experience_position'">В должностях</span>
                                                <span v-if="data.query2_fields.length === 1 && data.query2_fields[0] === 'experience_description'">В обязанностях</span>
                                                <span v-if="data.query2_fields.length > 1">В {{ data.query2_fields.length }} разделах резюме</span>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <v-treeview
                                                    v-model="data.query2_fields"
                                                    :items="query_fields"
                                                    selectable
                                                    activatable
                                                    open-all
                                                ></v-treeview>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                                <v-btn
                                    v-if="queries === 2"
                                    @click="queries++"
                                    small
                                    right
                                    text
                                    color="primary"
                                    class="mb-3"
                                >
                                    Добавить ещё поле
                                </v-btn>
                                <v-row v-if="queries === 3">
                                    <v-col xs="10" md="10">
                                        <v-combobox
                                            v-model="data.query3"
                                            :loading="autocomplete3.loading"
                                            :items="autocomplete3.items"
                                            :search-input.sync="autocomplete3.search"
                                            :error-messages="errors.query3"
                                            cache-items
                                            label="Поиск по резюме"
                                            hide-no-data
                                            hide-details
                                            class="mb-0"
                                        />
                                    </v-col>
                                    <v-col xs="2" md="2">
                                        <v-btn
                                            v-if="queries === 3"
                                            @click="data.query3 = ''; data.query3_logic = 'all'; data.query3_fields = ['everywhere']; queries--"
                                            x-small
                                            right
                                            fab
                                            icon
                                            class="mt-4"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <div v-if="queries === 3">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs,  }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="grey--text custom-transform-class text-none mb-3 ma-0 pa-0 mr-5"
                                                dark
                                                text
                                            >
                                                <v-icon>mdi-menu-down</v-icon>
                                                <span v-if="data.query3_logic === 'all'">Все слова</span>
                                                <span v-if="data.query3_logic === 'any'">Любое из слов</span>
                                                <span v-if="data.query3_logic === 'phrase'">Точная фраза</span>
                                                <span v-if="data.query3_logic === 'except'">Не встречаются</span>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text class="pa-0">
                                                <v-list class="ma-0 pa-0">
                                                    <v-list-item-group
                                                        v-model="data.query3_logic"
                                                    >
                                                        <v-list-item value="all">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Все слова</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item value="any">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Любое из слов</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item value="phrase">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Точная фраза</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item value="except">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Не встречаются</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list-item-group>
                                                </v-list>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                    <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs,  }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="grey--text custom-transform-class text-none mb-3 ma-0 pa-0"
                                                dark
                                                text
                                            >
                                                <v-icon>mdi-menu-down</v-icon>
                                                <span v-if="data.query3_fields.length === 1 && data.query3_fields[0] === 'everywhere'">Везде</span>
                                                <span v-if="data.query3_fields.length === 1 && data.query3_fields[0] === 'title'">В названии резюме</span>
                                                <span v-if="data.query3_fields.length === 1 && data.query3_fields[0] === 'education'">В образовании</span>
                                                <span v-if="data.query3_fields.length === 1 && data.query3_fields[0] === 'skills'">В ключевых навыках</span>
                                                <span v-if="data.query3_fields.length === 1 && data.query3_fields[0] === 'experience'">В опыте работы</span>
                                                <span v-if="data.query3_fields.length === 1 && data.query3_fields[0] === 'experience_company'">В компаниях и отраслях</span>
                                                <span v-if="data.query3_fields.length === 1 && data.query3_fields[0] === 'experience_position'">В должностях</span>
                                                <span v-if="data.query3_fields.length === 1 && data.query3_fields[0] === 'experience_description'">В обязанностях</span>
                                                <span v-if="data.query3_fields.length > 1">В {{ data.query3_fields.length }} разделах резюме</span>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-text>
                                                <v-treeview
                                                    v-model="data.query3_fields"
                                                    :items="query_fields"
                                                    selectable
                                                    activatable
                                                    open-all
                                                ></v-treeview>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </div>
                                <v-progress-linear v-if="filterDictionaries.loading" indeterminate class="mb-4" />
                                <v-alert v-if="filterDictionaries.error" type="error" text dense>
                                    {{ filterDictionaries.error }} <v-btn small text @click="searchDictionaries">Повторить</v-btn>
                                </v-alert>
                                <v-row>
                                    <v-col cols="12" md="4">Резюме за период</v-col>
                                    <v-col cols="12" md="8">
                                        <v-btn-toggle v-model="data.period" mandatory class="resume-period-buttons">
                                            <v-btn v-for="item in resumePeriods" :key="item.id" :value="item.id" small>{{ item.name }}</v-btn>
                                        </v-btn-toggle>
                                        <div v-for="(error, index) in errors.period" :key="index" class="error--text caption">{{ error }}</div>
                                        <v-row v-if="data.period === 'interval'" class="mt-2">
                                            <v-col cols="12" sm="6">
                                                <v-text-field v-model="data.date_from" label="С даты" type="date" outlined dense
                                                    :error-messages="errors.date_from" />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field v-model="data.date_to" label="По дату" type="date" outlined dense
                                                    :min="data.date_from" :error-messages="errors.date_to" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-2 pt-0">
                                        Регион
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-btn
                                            @click="showWorldPopup"
                                            outlined
                                            color="primary"
                                            :loading="world.loading"
                                        >
                                            Выбрать регионы
                                        </v-btn>
                                        <div v-for="(error, index) in errors.areas" :key="index" class="error--text caption mt-2">
                                            {{ error }}
                                        </div>
                                        <v-alert v-if="world.error" type="error" text dense class="mt-2">
                                            {{ world.error }}
                                            <v-btn @click="searchWorld" :disabled="world.loading" text small>
                                                Повторить
                                            </v-btn>
                                        </v-alert>
                                        <v-list
                                            class="ml-0 mt-2 pa-0"
                                            dense
                                        >
                                            <v-list-item
                                                v-for="(world) in worldSelected"
                                                :key="world.id"
                                            >
                                                <template
                                                    v-slot:default="{ active }"
                                                >
                                                    <v-list-item-action
                                                        class="ma-0 pa-0"
                                                    >
                                                        <v-btn
                                                            @click="removeWorld(world)"
                                                            x-small
                                                            icon
                                                        >
                                                            <v-icon small color="grey lighten-1">mdi-close</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content class="pa-0">
                                                        <v-list-item-title class="pl-2">
                                                            {{ world.name }}
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle v-if="world.path" class="pl-2">
                                                            {{ world.path }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                        <v-select
                                            v-model="data.relocation"
                                            :error-messages="errors.relocation"
                                            :items="relocation.data"
                                            :cache-items="true"
                                            item-text="name"
                                            item-value="id"
                                            class="mt-2 pt-0"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row class="pt-1" v-if="metroByCity.length">
                                    <v-col cols="12" md="4" class="mt-2 pt-0">
                                        Метро
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-autocomplete
                                            @change="addMetro"
                                            v-model="temp.metro"
                                            :items="metroByCity"
                                            item-text="name"
                                            item-value="hh_id"
                                            :error-messages="errors.metro"
                                            name="metro"
                                            label="Метро"
                                            class="mt-0 pt-0"
                                        >
                                            <template slot="item" slot-scope="data">
                                                <v-icon
                                                    :color="'#' + data.item.color"
                                                >
                                                    mdi-circle-medium
                                                </v-icon>
                                                {{ data.item.name }}
                                            </template>
                                        </v-autocomplete>
                                        <v-list
                                            class="ml-0 mt-0 pa-0"
                                            dense
                                        >
                                            <v-list-item
                                                v-for="(metro) in metroSelected"
                                                :key="metro.hh_id"
                                            >
                                                <template
                                                    v-slot:default="{ active }"
                                                >
                                                    <v-list-item-action
                                                        class="ma-0 pa-0"
                                                    >
                                                        <v-btn
                                                            @click="removeMetro(metro)"
                                                            x-small
                                                            icon
                                                        >
                                                            <v-icon small color="grey lighten-1">mdi-close</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content class="pa-0">
                                                        <v-list-item-title class="pl-2">
                                                            {{ metro.name }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-2 pt-0">
                                        Опыт в отрасли
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <chip-select-field v-if="data.filter_exp_industry.length"
                                            :items="industriesSelected" label="Опыт в отрасли"
                                            :expanded="exp.show" :errors="errors.filter_exp_industry"
                                            @open="exp.show = true" @remove="removeIndustry" />
                                        <v-btn v-else @click="exp.show = true" outlined color="primary" aria-label="Добавить: Опыт в отрасли">
                                            Добавить <v-icon right small>mdi-plus</v-icon>
                                        </v-btn>
                                        <template v-if="!data.filter_exp_industry.length">
                                            <div v-for="(error, index) in errors.filter_exp_industry" :key="index" class="error--text caption">
                                                {{ error }}
                                            </div>
                                        </template>
                                        <v-select
                                            v-if="data.filter_exp_industry.length"
                                            v-model="data.filter_exp_period"
                                            :error-messages="errors.filter_exp_period"
                                            :items="exp.period"
                                            :cache-items="true"
                                            item-text="name"
                                            item-value="id"
                                            class="d-inline-block mt-2 pt-0"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-0 pt-0">Статус поиска</v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-checkbox v-for="item in filterDictionaries.data.job_search_statuses_employer || []" :key="item.id" v-model="data.job_search_status"
                                            :value="item.id" :label="item.name" hide-details class="my-0 py-0" />
                                        <div v-for="(error, index) in errors.job_search_status" :key="index" class="error--text caption">{{ error }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-0 pt-0">Командировки</v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-checkbox v-for="item in business_trip_readiness.data" :key="item.id" v-model="data.business_trip_readiness"
                                            :value="item.id" :label="item.name" hide-details class="my-0 py-0" />
                                        <div v-for="(error, index) in errors.business_trip_readiness" :key="index" class="error--text caption">{{ error }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-5 pt-0">
                                        Возраст и фото
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        от
                                        <v-text-field
                                            v-model="data.age_from"
                                            :error-messages="errors.age_from"
                                            name="age_from"
                                            class="d-inline-block mx-2"
                                            type="text">
                                        </v-text-field>
                                        до
                                        <v-text-field
                                            v-model="data.age_to"
                                            :error-messages="errors.age_to"
                                            name="age_to"
                                            class="d-inline-block mx-2"
                                            type="text">
                                        </v-text-field>
                                        <v-checkbox
                                            v-model="data.only_with_age"
                                            label="Не показывать резюме без указания возраста"
                                            class="ma-0 pa-0"
                                        ></v-checkbox>
                                        <v-checkbox
                                            v-model="data.only_with_photo"
                                            label="Только с фотографией"
                                            class="mt-0 pt-0"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-0 pt-0">Тип занятости</v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-checkbox v-for="item in filterDictionaries.data.resume_employment_form || []" :key="item.id" v-model="data.employment_form"
                                            :value="item.id" :label="item.name" hide-details class="my-0 py-0" />
                                        <div v-if="data.employment.length" class="caption mt-2">
                                            Сохранённые значения занятости: {{ legacyFilterNames('employment') }}
                                            <v-btn small text @click="data.employment = []">Сбросить</v-btn>
                                        </div>
                                        <div v-for="(error, index) in errors.employment_form" :key="index" class="error--text caption">{{ error }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-0 pt-0">Формат работы</v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-checkbox v-for="item in filterDictionaries.data.resume_work_format || []" :key="item.id" v-model="data.work_format"
                                            :value="item.id" :label="item.name" hide-details class="my-0 py-0" />
                                        <div v-if="data.schedule.length" class="caption mt-2">
                                            Сохранённые значения графика: {{ legacyFilterNames('schedule') }}
                                            <v-btn small text @click="data.schedule = []">Сбросить</v-btn>
                                        </div>
                                        <div v-for="(error, index) in errors.work_format" :key="index" class="error--text caption">{{ error }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-0 pt-0">
                                        Общий опыт
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                       <v-checkbox
                                            v-model="data.experience"
                                            label="Нет опыта"
                                            value="noExperience"
                                            hide-details
                                            class="my-0 py-0"
                                        ></v-checkbox>
                                        <v-checkbox
                                            v-model="data.experience"
                                            label="От 1 года до 3 лет"
                                            value="between1And3"
                                            hide-details
                                            class="my-0 py-0"
                                        ></v-checkbox>
                                        <v-checkbox
                                            v-model="data.experience"
                                            label="От 3 до 6 лет"
                                            value="between3And6"
                                            hide-details
                                            class="my-0 py-0"
                                        ></v-checkbox>
                                        <v-checkbox
                                            v-model="data.experience"
                                            label="Более 6 лет"
                                            value="moreThan6"
                                            hide-details
                                            class="my-0 py-0"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">Специализация</v-col>
                                    <v-col cols="12" md="8">
                                        <chip-select-field v-if="data.specialization.length" :items="specializationSelected" label="Специализация"
                                            :loading="specialization.loading" :expanded="specialization.show" :errors="errors.specialization"
                                            @open="showSpecializationPopup" @remove="removeSpecializationById" />
                                        <v-btn v-else @click="showSpecializationPopup" outlined color="primary"
                                            :loading="specialization.loading" aria-label="Добавить: Специализация">
                                            Добавить <v-icon right small>mdi-plus</v-icon>
                                        </v-btn>
                                        <template v-if="!data.specialization.length">
                                            <div v-for="(error, index) in errors.specialization" :key="index" class="error--text caption">
                                                {{ error }}
                                            </div>
                                        </template>
                                        <v-alert v-if="specialization.error" type="error" text dense>
                                            {{ specialization.error }}
                                            <v-btn small text :loading="specialization.loading" @click="searchSpecialization">Повторить</v-btn>
                                        </v-alert>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-1 pt-0">
                                        Пол
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-radio-group
                                            v-model="data.gender"
                                            class="mt-0 pt-0"
                                        >
                                            <v-radio
                                                label="Не имеет значения"
                                                value="unknown"
                                                class="mt-0 pt-0"
                                            ></v-radio>
                                            <v-radio
                                                label="Мужской"
                                                value="male"
                                                class="mt-0 pt-0"
                                            ></v-radio>
                                            <v-radio
                                                label="Женский"
                                                value="female"
                                                class="mt-0 pt-0"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-5 pt-0">
                                        Уровень дохода
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        от
                                        <v-text-field
                                            v-model="data.salary_from"
                                            :error-messages="errors.salary_from"
                                            name="salary_from"
                                            class="d-inline-block mx-2"
                                            type="text">
                                        </v-text-field>
                                        до
                                        <v-text-field
                                            v-model="data.salary_to"
                                            :error-messages="errors.salary_to"
                                            name="salary_to"
                                            class="d-inline-block mx-2"
                                            type="text">
                                        </v-text-field>
                                        <v-select
                                            v-model="data.currency"
                                            :error-messages="errors.currency"
                                            :items="currency.data"
                                            :cache-items="true"
                                            item-text="name"
                                            item-value="code"
                                            label="Валюта"
                                            class="d-inline-block ml-2"
                                        ></v-select>
                                        <v-checkbox
                                            v-model="data.only_with_salary"
                                            label="Не показывать резюме без зарплаты"
                                            class="ma-0 pa-0"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row class="pt-1">
                                    <v-col cols="12" md="4" class="mt-2 pt-0">
                                        Гражданство
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-autocomplete
                                            @change="addCitizenship"
                                            v-model="temp.citizenship"
                                            :items="country.data"
                                            item-text="name"
                                            item-value="hh_id"
                                            :error-messages="errors.citizenship"
                                            name="citizenship"
                                            label="Гражданство"
                                            class="mt-0 pt-0"
                                        >
                                            <template slot="item" slot-scope="data">
                                                {{ data.item.name }}
                                            </template>
                                        </v-autocomplete>
                                        <v-list
                                            class="ml-0 mt-0 pa-0"
                                            dense
                                        >
                                            <v-list-item
                                                v-for="(country) in citizenshipSelected"
                                                :key="country.hh_id"
                                            >
                                                <template
                                                    v-slot:default="{ active }"
                                                >
                                                    <v-list-item-action
                                                        class="ma-0 pa-0"
                                                    >
                                                        <v-btn
                                                            @click="removeCitizenship(country)"
                                                            x-small
                                                            icon
                                                        >
                                                            <v-icon small color="grey lighten-1">mdi-close</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content class="pa-0">
                                                        <v-list-item-title class="pl-2">
                                                            {{ country.name }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-0 pt-0">
                                        Образование
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                       <v-checkbox
                                            v-model="data.education"
                                            label="Среднее"
                                            value="secondary"
                                            hide-details
                                            class="my-0 py-0"
                                        />
                                       <v-checkbox
                                            v-model="data.education"
                                            label="Среднее специальное"
                                            value="special_secondary"
                                            hide-details
                                            class="my-0 py-0"
                                        />
                                       <v-checkbox
                                            v-model="data.education"
                                            label="Неоконченное высшее"
                                            value="unfinished_higher"
                                            hide-details
                                            class="my-0 py-0"
                                        />
                                       <v-checkbox
                                            v-model="data.education"
                                            label="Высшее"
                                            value="higher"
                                            hide-details
                                            class="my-0 py-0"
                                        />
                                       <v-checkbox
                                            v-model="data.education"
                                            label="Бакалавр"
                                            value="bachelor"
                                            hide-details
                                            class="my-0 py-0"
                                        />
                                       <v-checkbox
                                            v-model="data.education"
                                            label="Магистр"
                                            value="master"
                                            hide-details
                                            class="my-0 py-0"
                                        />
                                       <v-checkbox
                                            v-model="data.education"
                                            label="Кандидат наук"
                                            value="candidate"
                                            hide-details
                                            class="my-0 py-0"
                                        />
                                       <v-checkbox
                                            v-model="data.education"
                                            label="Доктор наук"
                                            value="doctor"
                                            hide-details
                                            class="my-0 py-0"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">Учебное заведение</v-col>
                                    <v-col cols="12" md="8">
                                        <v-autocomplete ref="institutionAutocomplete" :value="data.educational_institution"
                                            @input="selectInstitution" @focus="sizeInstitutionMenu" :items="institutionItems"
                                            :menu-props="{maxWidth: institution.menuWidth, offsetOverflow: true}"
                                            :search-input.sync="institution.search" :loading="institution.loading"
                                            :error-messages="errors.educational_institution" :no-data-text="institution.error || (institution.loading ? 'Загрузка…' : (institution.search || '').trim().length < 2 ? 'Введите не менее двух символов' : 'Ничего не найдено')"
                                            :item-text="institutionName" item-value="id" return-object multiple chips small-chips deletable-chips
                                            hide-selected no-filter label="Учебное заведение" outlined dense>
                                            <template v-slot:item="{item}">
                                                <v-list-item-content class="institution-suggestion">
                                                    <v-list-item-title>{{ institutionName(item) }}</v-list-item-title>
                                                    <v-list-item-subtitle v-if="item.acronym">{{ item.text }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </template>
                                        </v-autocomplete>
                                        <div v-if="institution.error" class="error--text caption">{{ institution.error }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">Навыки</v-col>
                                    <v-col cols="12" md="8">
                                        <skill-chip-select v-model="data.skill" :items="skills.items" :loading="skills.loading"
                                            :errors="errors.skill" :error="skills.error" @search="autosuggestSkill" />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">Разрешение на работу</v-col>
                                    <v-col cols="12" md="8">
                                        <v-autocomplete ref="workTicketAutocomplete" :value="data.work_ticket" @input="selectWorkTicket"
                                            :search-input.sync="country.search" :items="country.data" :loading="country.loading"
                                            item-text="name" item-value="hh_id" :error-messages="errors.work_ticket"
                                            label="Разрешение на работу" hide-selected multiple chips small-chips deletable-chips outlined dense />
                                        <div v-if="country.error" class="error--text caption">
                                            {{ country.error }} <v-btn small text @click="searchCountry">Повторить</v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row class="mb-5">
                                    <v-col cols="12" md="4" class="mt-3 pt-2">
                                        Категория прав
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-btn-toggle
                                            v-model="data.driver_license_type"
                                            dense borderless
                                            class="resume-period-buttons"
                                            multiple
                                        >
                                            <v-btn v-for="item in filterDictionaries.data.driver_license_types || []" :key="item.id" :value="item.id">{{ item.name }}</v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-3 pt-0">
                                        Автомобиль
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-checkbox
                                            v-model="data.only_with_vehicle"
                                            label="Есть личный автомобиль"
                                            class="mt-0 pt-0"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-2 pt-0">
                                        Языки
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <!-- Список выбранных языков -->
                                        <div v-if="data.languages && data.languages.length > 0" class="mb-3">
                                            <v-chip
                                                v-for="(lang, index) in data.languages"
                                                :key="index"
                                                close
                                                @click:close="removeLanguage(index)"
                                                class="mr-2 mb-2"
                                            >
                                                {{ getLanguageName(lang.language_id) }} — {{ getLanguageLevelName(lang.level_id) }}
                                            </v-chip>
                                        </div>

                                        <!-- Форма добавления нового языка -->
                                        <div class="d-flex align-center">
                                            <v-select
                                                v-model="newLanguage.language_id"
                                                :items="language.language"
                                                :cache-items="true"
                                                item-text="name"
                                                item-value="id"
                                                label="Выберите язык"
                                                class="mr-3"
                                                style="max-width: 250px;"
                                            />
                                            <v-select
                                                v-model="newLanguage.level_id"
                                                :items="language.level"
                                                :cache-items="true"
                                                item-text="name"
                                                item-value="id"
                                                label="Уровень"
                                                class="mr-3"
                                                style="max-width: 220px;"
                                            />
                                            <v-btn
                                                @click="addLanguage"
                                                :disabled="!newLanguage.language_id || !newLanguage.level_id"
                                                color="primary"
                                                small
                                            >
                                                Добавить
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-1 pt-0">
                                        Сортировка
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-radio-group
                                            v-model="data.sort"
                                            class="mt-0 pt-0"
                                        >
                                            <v-radio
                                                label="По дате изменения"
                                                value="publication_time"
                                                class="mt-0 pt-0"
                                            ></v-radio>
                                            <v-radio
                                                label="По убыванию зарплат"
                                                value="salary_desc"
                                                class="mt-0 pt-0"
                                            ></v-radio>
                                            <v-radio
                                                label="По возрастанию зарплаты"
                                                value="salary_asc"
                                                class="mt-0 pt-0"
                                            ></v-radio>
                                            <v-radio
                                                label="По соответствию"
                                                value="relevance"
                                                class="mt-0 pt-0"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4" class="mt-1 pt-0">
                                        Показывать на странице
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-0 pt-0">
                                        <v-radio-group
                                            v-model="data.per_page"
                                            class="mt-0 pt-0"
                                        >
                                            <v-radio
                                                label="20"
                                                value="20"
                                                class="mt-0 pt-0"
                                            ></v-radio>
                                            <v-radio
                                                label="50"
                                                value="50"
                                                class="mt-0 pt-0"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <favorite-search-button @click="openSaveSearch" :disabled="progress || savedSearch.loading" />
                                <v-btn
                                    :disabled="progress || savedSearch.loading"
                                    type="submit"
                                    color="primary"
                                >
                                    Найти
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="resume.length > 0" class="mx-0" align="center">
            <v-spacer />
            <v-btn
                v-if="hide"
                @click="openSaveSearch"
                :disabled="progress || savedSearch.loading"
                type="button"
                text
                small
                color="primary"
                class="text-none save-autosearch-link"
            >
                <favorite-search-icon class="mr-2" />
                <span>Сохранить фильтр в автопоиск</span>
            </v-btn>
            <v-btn @click="options.show = true" icon><v-icon>mdi-cog</v-icon></v-btn>
        </v-row>
        <v-row
            v-for="(r) in resume"
            :key="r.id"
        >
            <v-col
                v-if="$moment(user.accessTill).diff($moment(), 'minutes') > 0 && (user.resumeBasicLimit > 0 || user.resumeExtraLimit > 0)"
                xs="12"
            >
                <v-card min-height="204px" :disabled="user.resumeHideViewed && r.history">
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>
                            <v-icon
                                v-if="r.history"
                                class="mr-1"
                                title="Просмотрено"
                                style="margin-top: -3px"
                            >
                                mdi-eye
                            </v-icon>
                            <router-link
                                :to="{ name: 'Resume', params: { id: r.id } }"
                                class="text-decoration-none"
                                target="_blank"
                            >
                                {{ r.title }}
                            </router-link>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <img
                            v-if="options.data.image && r.photo"
                            @click="photo = [r.photo.medium], lightbox = !lightbox"
                            :src="r.photo.medium"
                            class="photo"
                            align="right"
                            width="60"
                        >
                        <v-chip
                            v-if="!!r.job_search_status"
                            class="mb-2"
                        >
                            {{ r.job_search_status.name }}
                        </v-chip>
                        <p v-if="r.age">
                            Возраст, лет: {{ r.age }}
                        </p>
                        <p v-if="r.salary">
                            Оплата: {{ r.salary.amount }}
                            <span v-if="r.salary.currency === 'RUR'">
                                руб.
                            </span>
                            <span v-if="r.salary.currency === 'EUR'">
                                EUR
                            </span>
                            <span v-if="r.salary.currency === 'USD'">
                                USD
                            </span>
                        </p>
                        <p v-if="options.data.experience_total && r.total_experience">
                            Опыт работы:
                            <span v-if="r.total_experience.months >= 12">
                                {{ Math.floor(r.total_experience.months / 12) }} лет
                            </span>
                            <span v-if="r.total_experience.months % 12 > 0">
                                {{ r.total_experience.months % 12 }} месяцев
                            </span>
                        </p>
                        <p v-if="options.data.area && r.area">
                            Регион:
                            <span>
                                {{ r.area.name }}
                            </span>
                        </p>
                        <div v-if="options.data.education_primary && r.education.primary && r.education.primary.length > 0" class="my-5">
                            Основное образование:
                            <br>
                            <div
                                v-for="(e, i) in r.education.primary"
                                :key="e.name + e.year + i"
                            >
                                {{ e.name }} ({{ e.year }})
                            </div>
                        </div>
                        <p v-if="options.data.experience_last && r.experience && r.experience.length > 0">
                            Последнее место работы: {{ r.experience[0].position }}
                            <br>
                            {{ r.experience[0].company }}, {{ $moment(r.experience[0].start).format('DD.MM.YYYY') }} - <span v-if="r.experience[0].end">{{ $moment(r.experience[0].end).format('DD.MM.YYYY') }}</span><span v-else>по настоящее время</span>
                        </p>
                        <div v-if="options.data.experience && r.experience && r.experience.length > 0">
                            Компании, в которых работал кандидат:
                            <br>
                            <div
                                v-for="(e, i) in r.experience"
                                :key="e.company + e.start + i"
                            >
                                {{ e.company }}, {{ $moment(e.start).format('DD.MM.YYYY') }} - <span v-if="e.end">{{ $moment(e.end).format('DD.MM.YYYY') }}</span><span v-else>по настоящее время</span>
                            </div>
                        </div>
                        <p v-if="options.data.updated_at" class="grey--text">
                            <span v-if="r.updated_at">
                                Обновлено
                                <span v-if="$moment(r.updated_at).add(1, 'years').isBefore($moment())">
                                    {{ $moment(r.updated_at).format('D MMMM YYYY HH:mm') }}
                                </span>
                                <span v-else>
                                    {{ $moment(r.updated_at).format('D MMMM HH:mm') }}
                                </span>
                            </span>
                            <span v-else>
                                Создано {{ $moment(r.created_at).format('D MMMM HH:mm') }}
                            </span>
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-pagination
            v-if="pages > 1"
            v-model="data.page"
            :length="pages"
            :disabled="progress"
            class="my-4"
        />
        <IndustryDialog
            v-model="exp.show"
            :items="exp.industry"
            :selection="data.filter_exp_industry"
            @save="data.filter_exp_industry = $event"
        />
        <ProfessionDialog
            v-model="specialization.show"
            :items="specialization.data"
            :selection="data.specialization"
            :loading="specialization.loading"
            :error="specialization.error"
            @save="data.specialization = $event"
            @retry="searchSpecialization"
        />
        <RegionDialog
            v-model="world.show"
            :items="world.data"
            :selection="data.areas"
            :loading="world.loading"
            :error="world.error"
            @save="saveWorld"
            @retry="searchWorld"
        />
        <v-dialog
            v-if="options.show"
            v-model="options.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Настройки</v-card-title>
                <v-form
                    @submit.prevent="updateSearchOptions"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-container>
                            <v-checkbox
                                v-model="options.data.updated_at"
                                label="Время изменения"
                                class="ma-0"
                            />
                            <v-checkbox
                                v-model="options.data.image"
                                label="Фото"
                                class="ma-0"
                            />
                            <v-checkbox
                                v-model="options.data.experience_last"
                                label="Последнее место работы"
                                class="ma-0"
                            />
                            <v-checkbox
                                v-model="options.data.area"
                                label="Регион"
                                class="ma-0"
                            />
                            <v-checkbox
                                v-model="options.data.education_primary"
                                label="Основное образование"
                                class="ma-0"
                            />
                            <v-checkbox
                                v-model="options.data.experience"
                                label="Названия компаний, в которых работали"
                                class="ma-0"
                            />
                            <v-checkbox
                                v-model="options.data.experience_total"
                                label="Опыт работы"
                                class="ma-0"
                            />
                            <v-checkbox
                                v-model="options.data.hide"
                                label="Скрывать просмотренные резюме"
                                class="ma-0"
                            />
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            @click="options.show = false"
                            :disabled="options.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="options.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <FsLightbox
            :toggler="lightbox"
            :sources="photo"
            type="image"
        />
        <saved-search-dialog
            v-model="savedSearch.show"
            :summary="savedSearch.summary"
            :progress="savedSearch.saving"
            :error="savedSearch.saveError"
            :name-errors="savedSearch.nameErrors"
            @save="saveSearch"
        />
        <v-snackbar v-model="savedSearch.success" color="success">Поиск сохранён в избранное</v-snackbar>
    </v-container>
</template>

<script>
import FsLightbox from "fslightbox-vue"
import IndustryDialog from '../IndustryDialog.vue'
import ProfessionDialog from '../ProfessionDialog.vue'
import RegionDialog from '../RegionDialog.vue'
import ChipSelectField from '../ChipSelectField.vue'
import SkillChipSelect from '../SkillChipSelect.vue'
import FavoriteSearchButton from '../FavoriteSearchButton.vue'
import FavoriteSearchIcon from '../FavoriteSearchIcon.vue'
import SavedSearchDialog from '../SavedSearchDialog.vue'
import {defaultSearchFilters, savedSearchFilters, restoreSearchFilters, summarizeSearchFilters} from '../../utils/searchFilters'

export default {
    name: "SearchController",
    components: {FsLightbox, IndustryDialog, ProfessionDialog, RegionDialog, ChipSelectField, SkillChipSelect, FavoriteSearchButton, FavoriteSearchIcon, SavedSearchDialog},
    data () {
        return {
            autocomplete1: {
                items: [],
                loading: false,
            },
            autocomplete2: {
                items: [],
                loading: false,
            },
            autocomplete3: {
                items: [],
                loading: false,
            },
            business_trip_readiness: { data: [] },
            filterDictionaries: { data: {}, loading: false, error: '' },
            country: { data: [], search: '', loading: false, error: '' },
            institution: { items: [], search: '', loading: false, error: '', request: 0, timer: null, menuWidth: 600 },
            resumePeriods: [
                { id: '0', name: 'Любой' }, { id: '1', name: 'Сутки' }, { id: '3', name: 'Три дня' },
                { id: '7', name: 'Неделю' }, { id: '30', name: 'Месяц' }, { id: '365', name: 'Год' },
                { id: 'interval', name: 'Интервал' },
            ],
            currency: {
                data: [
                    {
                        code: 'RUR',
                        name: 'Руб.',
                    },
                    {
                        code: 'EUR',
                        name: 'EUR',
                    },
                    {
                        code: 'USD',
                        name: 'USD',
                    },
                ],
            },
            data: defaultSearchFilters(),
            savedSearch: {
                show: false,
                loading: false,
                restoring: false,
                saving: false,
                success: false,
                error: '',
                saveError: '',
                nameErrors: [],
                filters: {},
                summary: [],
            },
            newLanguage: {
                language_id: '',
                level_id: '',
            },
            education: {
                data: [
                    {
                        id: 'secondary',
                        name: 'Среднее',
                    },
                    {
                        id: 'special_secondary',
                        name: 'Среднее специальное',
                    },
                    {
                        id: 'unfinished_higher',
                        name: 'Неоконченное высшее',
                    },
                    {
                        id: 'higher',
                        name: 'Высшее',
                    },
                    {
                        id: 'bachelor',
                        name: 'Бакалавр',
                    },
                    {
                        id: 'master',
                        name: 'Магистр',
                    },
                    {
                        id: 'candidate',
                        name: 'Кандидат наук',
                    },
                    {
                        id: 'doctor',
                        name: 'Доктор наук',
                    },
                ],
            },
            errors: {
                age_from: [],
                age_to: [],
                areas: [],
                business_trip_readiness: [],
                employment_form: [], work_format: [], job_search_status: [], specialization: [],
                educational_institution: [], period: [], date_from: [], date_to: [],
                citizenship: [],
                currency: [],
                filter_exp_industry: [],
                education: [],
                query1: [],
                query2: [],
                query3: [],
                salary_from: [],
                salary_to: [],
                skill: [],
                work_ticket: [],
                metro: [],
            },
            exp: {
                show: false,
                industry: [
                    {
                        "id": "5",
                        "name": "Перевозки, логистика, склад, ВЭД",
                    },
                    {
                        "id": "5.461",
                        "name": "\u00A0\u00A0\u00A0\u00A0Авиаперевозки"
                    },
                    {
                        "id": "5.462",
                        "name": "\u00A0\u00A0\u00A0\u00A0Автомобильные перевозки"
                    },
                    {
                        "id": "5.463",
                        "name": "\u00A0\u00A0\u00A0\u00A0Железнодорожные перевозки"
                    },
                    {
                        "id": "5.464",
                        "name": "\u00A0\u00A0\u00A0\u00A0Морские, речные перевозки"
                    },
                    {
                        "id": "5.465",
                        "name": "\u00A0\u00A0\u00A0\u00A0Транспортно-логистические комплексы, порты (воздушный, водный, железнодорожный)"
                    },
                    {
                        "id": "5.466",
                        "name": "\u00A0\u00A0\u00A0\u00A0Складские услуги"
                    },
                    {
                        "id": "5.467",
                        "name": "\u00A0\u00A0\u00A0\u00A0Курьерская, почтовая доставка"
                    },
                    {
                        "id": "5.468",
                        "name": "\u00A0\u00A0\u00A0\u00A0ВЭД, таможенное оформление"
                    },
                    {
                        "id": "7",
                        "name": "Информационные технологии, системная интеграция, интернет",
                    },
                    {
                        "id": "7.538",
                        "name": "\u00A0\u00A0\u00A0\u00A0Интернет-провайдер"
                    },
                    {
                        "id": "7.539",
                        "name": "\u00A0\u00A0\u00A0\u00A0Системная интеграция,  автоматизации технологических и бизнес-процессов предприятия, ИТ-консалтинг"
                    },
                    {
                        "id": "7.540",
                        "name": "\u00A0\u00A0\u00A0\u00A0Разработка программного обеспечения"
                    },
                    {
                        "id": "7.541",
                        "name": "\u00A0\u00A0\u00A0\u00A0Интернет-компания (поисковики, платежные системы, соц.сети, информационно-познавательные и развлекательные ресурсы, продвижение сайтов и прочее)"
                    },
                    {
                        "id": "8",
                        "name": "Электроника, приборостроение, бытовая техника, компьютеры и оргтехника",
                    },
                    {
                        "id": "8.478",
                        "name": "\u00A0\u00A0\u00A0\u00A0Бытовая техника, электроника, климатическое оборудование (производство)"
                    },
                    {
                        "id": "8.479",
                        "name": "\u00A0\u00A0\u00A0\u00A0Бытовая техника, электроника, климатическое оборудование (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "8.480",
                        "name": "\u00A0\u00A0\u00A0\u00A0Бытовая техника, электроника, климатическое оборудование (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "8.481",
                        "name": "\u00A0\u00A0\u00A0\u00A0Промышленное, бытовое электрооборудование и электротехника (производство)"
                    },
                    {
                        "id": "8.482",
                        "name": "\u00A0\u00A0\u00A0\u00A0Промышленное, бытовое электрооборудование и электротехника (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "8.483",
                        "name": "\u00A0\u00A0\u00A0\u00A0Промышленное, бытовое электрооборудование и электротехника (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "8.484",
                        "name": "\u00A0\u00A0\u00A0\u00A0Электронно-вычислительная, оптическая, контрольно-измерительная техника, радиоэлектроника, автоматика (производство)"
                    },
                    {
                        "id": "8.485",
                        "name": "\u00A0\u00A0\u00A0\u00A0Электронно-вычислительная, оптическая, контрольно-измерительная техника, радиоэлектроника, автоматика (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "8.486",
                        "name": "\u00A0\u00A0\u00A0\u00A0Электронно-вычислительная, оптическая, контрольно-измерительная техника, радиоэлектроника, автоматика (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "9",
                        "name": "Телекоммуникации, связь",
                    },
                    {
                        "id": "9.399",
                        "name": "\u00A0\u00A0\u00A0\u00A0Мобильная связь"
                    },
                    {
                        "id": "9.400",
                        "name": "\u00A0\u00A0\u00A0\u00A0Фиксированная связь"
                    },
                    {
                        "id": "9.401",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оптоволоконная связь"
                    },
                    {
                        "id": "9.402",
                        "name": "\u00A0\u00A0\u00A0\u00A0Спутниковая связь"
                    },
                    {
                        "id": "11",
                        "name": "СМИ, маркетинг, реклама, BTL, PR, дизайн, продюсирование",
                    },
                    {
                        "id": "11.452",
                        "name": "\u00A0\u00A0\u00A0\u00A0Издательская деятельность"
                    },
                    {
                        "id": "11.453",
                        "name": "\u00A0\u00A0\u00A0\u00A0Производство мультимедиа, контента, редакторская деятельность"
                    },
                    {
                        "id": "11.454",
                        "name": "\u00A0\u00A0\u00A0\u00A0Распространение телепрограмм, кино (кабельное телевидение)"
                    },
                    {
                        "id": "11.455",
                        "name": "\u00A0\u00A0\u00A0\u00A0Киностудии и студии звукозаписи"
                    },
                    {
                        "id": "11.456",
                        "name": "\u00A0\u00A0\u00A0\u00A0Теле- и радиовещание"
                    },
                    {
                        "id": "11.457",
                        "name": "\u00A0\u00A0\u00A0\u00A0Продюсерский центр"
                    },
                    {
                        "id": "11.458",
                        "name": "\u00A0\u00A0\u00A0\u00A0Распространение мультимедиа и печатной продукции"
                    },
                    {
                        "id": "11.459",
                        "name": "\u00A0\u00A0\u00A0\u00A0Маркетинговые, рекламные, BTL, дизайнерские, Event-, PR-агентства, организация выставок"
                    },
                    {
                        "id": "11.460",
                        "name": "\u00A0\u00A0\u00A0\u00A0Производство печатной, полиграфической продукции"
                    },
                    {
                        "id": "11.685",
                        "name": "\u00A0\u00A0\u00A0\u00A0Производство и продажа рекламно-сувенирной продукции"
                    },
                    {
                        "id": "13",
                        "name": "Строительство, недвижимость, эксплуатация, проектирование",
                    },
                    {
                        "id": "13.654",
                        "name": "\u00A0\u00A0\u00A0\u00A0Девелопмент"
                    },
                    {
                        "id": "13.655",
                        "name": "\u00A0\u00A0\u00A0\u00A0Строительство объектов нефтегазовой отрасли"
                    },
                    {
                        "id": "13.656",
                        "name": "\u00A0\u00A0\u00A0\u00A0Строительство объектов металлургической отрасли"
                    },
                    {
                        "id": "13.657",
                        "name": "\u00A0\u00A0\u00A0\u00A0Строительство объектов телекоммуникационной отрасли"
                    },
                    {
                        "id": "13.658",
                        "name": "\u00A0\u00A0\u00A0\u00A0Строительство энергетическое"
                    },
                    {
                        "id": "13.659",
                        "name": "\u00A0\u00A0\u00A0\u00A0Строительство промышленное"
                    },
                    {
                        "id": "13.660",
                        "name": "\u00A0\u00A0\u00A0\u00A0Строительство коммерческих объектов (торговые площади, офисные здания)"
                    },
                    {
                        "id": "13.661",
                        "name": "\u00A0\u00A0\u00A0\u00A0Строительство жилищное"
                    },
                    {
                        "id": "13.662",
                        "name": "\u00A0\u00A0\u00A0\u00A0Строительство дорожное и инфраструктурное"
                    },
                    {
                        "id": "13.663",
                        "name": "\u00A0\u00A0\u00A0\u00A0Архитектура, проектирование"
                    },
                    {
                        "id": "13.664",
                        "name": "\u00A0\u00A0\u00A0\u00A0Управление и эксплуатация недвижимости"
                    },
                    {
                        "id": "13.665",
                        "name": "\u00A0\u00A0\u00A0\u00A0Консалтинг, оценка в недвижимости"
                    },
                    {
                        "id": "13.666",
                        "name": "\u00A0\u00A0\u00A0\u00A0Агентские услуги в недвижимости"
                    },
                    {
                        "id": "15",
                        "name": "Автомобильный бизнес",
                    },
                    {
                        "id": "15.542",
                        "name": "\u00A0\u00A0\u00A0\u00A0Легковые, грузовые автомобили, мототехника, автобусы, троллейбусы (производство)"
                    },
                    {
                        "id": "15.543",
                        "name": "\u00A0\u00A0\u00A0\u00A0Легковые, грузовые автомобили, мототехника, автобусы, троллейбусы (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "15.544",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная торговля автомобилями (дилерский центр)"
                    },
                    {
                        "id": "15.545",
                        "name": "\u00A0\u00A0\u00A0\u00A0Автокомпоненты, запчасти (производство)"
                    },
                    {
                        "id": "15.546",
                        "name": "\u00A0\u00A0\u00A0\u00A0Автокомпоненты, запчасти, шины (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "15.547",
                        "name": "\u00A0\u00A0\u00A0\u00A0Автозапчасти, шины (розничная торговля)"
                    },
                    {
                        "id": "15.548",
                        "name": "\u00A0\u00A0\u00A0\u00A0Техническое обслуживание, ремонт автомобилей"
                    },
                    {
                        "id": "15.549",
                        "name": "\u00A0\u00A0\u00A0\u00A0Финансовые услуги (кэптивные банки и лизинговые компании)"
                    },
                    {
                        "id": "19",
                        "name": "Лесная промышленность, деревообработка",
                    },
                    {
                        "id": "19.620",
                        "name": "\u00A0\u00A0\u00A0\u00A0Деревообработка (производство)"
                    },
                    {
                        "id": "19.621",
                        "name": "\u00A0\u00A0\u00A0\u00A0Продукция деревообработки (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "19.622",
                        "name": "\u00A0\u00A0\u00A0\u00A0Столярно-строительные изделия (производство)"
                    },
                    {
                        "id": "19.623",
                        "name": "\u00A0\u00A0\u00A0\u00A0Столярно-строительные изделия (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "19.624",
                        "name": "\u00A0\u00A0\u00A0\u00A0Целлюлозно-бумажное производство"
                    },
                    {
                        "id": "19.625",
                        "name": "\u00A0\u00A0\u00A0\u00A0Целлюлозно-бумажная продукция (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "24",
                        "name": "Металлургия, металлообработка",
                    },
                    {
                        "id": "24.633",
                        "name": "\u00A0\u00A0\u00A0\u00A0Черная металлургия (производство чугуна, стали, проката)"
                    },
                    {
                        "id": "24.634",
                        "name": "\u00A0\u00A0\u00A0\u00A0Продукция черной металлургии (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "24.635",
                        "name": "\u00A0\u00A0\u00A0\u00A0Цветная металлургия (выплавка, металлопрокат)"
                    },
                    {
                        "id": "24.636",
                        "name": "\u00A0\u00A0\u00A0\u00A0Продукция цветной металлургии (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "24.637",
                        "name": "\u00A0\u00A0\u00A0\u00A0Драгоценные, благородные и редкие металлы (производство)"
                    },
                    {
                        "id": "24.638",
                        "name": "\u00A0\u00A0\u00A0\u00A0Драгоценные, благородные и редкие металлы (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "24.639",
                        "name": "\u00A0\u00A0\u00A0\u00A0Металлические изделия, металлоконструкции (производство)"
                    },
                    {
                        "id": "24.640",
                        "name": "\u00A0\u00A0\u00A0\u00A0Металлические изделия, металлоконструкции (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27",
                        "name": "Продукты питания",
                    },
                    {
                        "id": "27.550",
                        "name": "\u00A0\u00A0\u00A0\u00A0Безалкогольные напитки (производство)"
                    },
                    {
                        "id": "27.551",
                        "name": "\u00A0\u00A0\u00A0\u00A0Безалкогольные напитки (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.552",
                        "name": "\u00A0\u00A0\u00A0\u00A0Вино (производство)"
                    },
                    {
                        "id": "27.553",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ликероводочная продукция (производство)"
                    },
                    {
                        "id": "27.554",
                        "name": "\u00A0\u00A0\u00A0\u00A0Пиво (производство)"
                    },
                    {
                        "id": "27.555",
                        "name": "\u00A0\u00A0\u00A0\u00A0Алкогольные напитки (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.556",
                        "name": "\u00A0\u00A0\u00A0\u00A0Детское питание (производство)"
                    },
                    {
                        "id": "27.557",
                        "name": "\u00A0\u00A0\u00A0\u00A0Детское питание (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.558",
                        "name": "\u00A0\u00A0\u00A0\u00A0Кондитерские изделия (производство)"
                    },
                    {
                        "id": "27.559",
                        "name": "\u00A0\u00A0\u00A0\u00A0Кондитерские изделия (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.560",
                        "name": "\u00A0\u00A0\u00A0\u00A0Консервированная продукция (производство)"
                    },
                    {
                        "id": "27.561",
                        "name": "\u00A0\u00A0\u00A0\u00A0Консервированная продукция (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.562",
                        "name": "\u00A0\u00A0\u00A0\u00A0Корма для животных (производство)"
                    },
                    {
                        "id": "27.563",
                        "name": "\u00A0\u00A0\u00A0\u00A0Корма для животных (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.564",
                        "name": "\u00A0\u00A0\u00A0\u00A0Макаронные изделия (производство)"
                    },
                    {
                        "id": "27.565",
                        "name": "\u00A0\u00A0\u00A0\u00A0Макаронные изделия (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.566",
                        "name": "\u00A0\u00A0\u00A0\u00A0Масложировая продукция (производство)"
                    },
                    {
                        "id": "27.567",
                        "name": "\u00A0\u00A0\u00A0\u00A0Масложировая продукция (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.568",
                        "name": "\u00A0\u00A0\u00A0\u00A0Молочная продукция (производство)"
                    },
                    {
                        "id": "27.569",
                        "name": "\u00A0\u00A0\u00A0\u00A0Молочная продукция (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.570",
                        "name": "\u00A0\u00A0\u00A0\u00A0Мука, крупы (производство)"
                    },
                    {
                        "id": "27.571",
                        "name": "\u00A0\u00A0\u00A0\u00A0Мука, крупы (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.572",
                        "name": "\u00A0\u00A0\u00A0\u00A0Мясная продукция (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.573",
                        "name": "\u00A0\u00A0\u00A0\u00A0Мясная продукция (производство)"
                    },
                    {
                        "id": "27.574",
                        "name": "\u00A0\u00A0\u00A0\u00A0Пищевые концентраты (производство)"
                    },
                    {
                        "id": "27.575",
                        "name": "\u00A0\u00A0\u00A0\u00A0Пищевые концентраты (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.576",
                        "name": "\u00A0\u00A0\u00A0\u00A0Рыба и морепродукты (производство)"
                    },
                    {
                        "id": "27.577",
                        "name": "\u00A0\u00A0\u00A0\u00A0Рыба и морепродукты (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.578",
                        "name": "\u00A0\u00A0\u00A0\u00A0Полуфабрикаты, в том числе замороженные (производство)"
                    },
                    {
                        "id": "27.579",
                        "name": "\u00A0\u00A0\u00A0\u00A0Полуфабрикаты, в том числе замороженные  (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.580",
                        "name": "\u00A0\u00A0\u00A0\u00A0Снеки (производство)"
                    },
                    {
                        "id": "27.581",
                        "name": "\u00A0\u00A0\u00A0\u00A0Снеки (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.582",
                        "name": "\u00A0\u00A0\u00A0\u00A0Сахар (производство)"
                    },
                    {
                        "id": "27.583",
                        "name": "\u00A0\u00A0\u00A0\u00A0Сахар (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.584",
                        "name": "\u00A0\u00A0\u00A0\u00A0Свежие овощи, фрукты (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.585",
                        "name": "\u00A0\u00A0\u00A0\u00A0Хлебобулочные изделия (производство)"
                    },
                    {
                        "id": "27.586",
                        "name": "\u00A0\u00A0\u00A0\u00A0Хлебобулочные изделия (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "27.587",
                        "name": "\u00A0\u00A0\u00A0\u00A0Чай, кофе (производство)"
                    },
                    {
                        "id": "27.588",
                        "name": "\u00A0\u00A0\u00A0\u00A0Чай, кофе (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "29",
                        "name": "Сельское хозяйство",
                    },
                    {
                        "id": "29.531",
                        "name": "\u00A0\u00A0\u00A0\u00A0Земледелие, растениеводство, животноводство"
                    },
                    {
                        "id": "29.532",
                        "name": "\u00A0\u00A0\u00A0\u00A0Рыболовство, рыбоводство"
                    },
                    {
                        "id": "29.533",
                        "name": "\u00A0\u00A0\u00A0\u00A0Сельскохозяйственная продукция (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "33",
                        "name": "Тяжелое машиностроение",
                    },
                    {
                        "id": "33.428",
                        "name": "\u00A0\u00A0\u00A0\u00A0Авиационная, вертолетная, аэрокосмическая промышленность"
                    },
                    {
                        "id": "33.429",
                        "name": "\u00A0\u00A0\u00A0\u00A0Продукция авиационной, аэрокосмической, вертолетной промышленности (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "33.430",
                        "name": "\u00A0\u00A0\u00A0\u00A0Продукция авиационной, аэрокосмической, вертолетной промышленности (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "33.431",
                        "name": "\u00A0\u00A0\u00A0\u00A0Двигатели (производство)"
                    },
                    {
                        "id": "33.432",
                        "name": "\u00A0\u00A0\u00A0\u00A0Двигатели (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "33.433",
                        "name": "\u00A0\u00A0\u00A0\u00A0Двигатели (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "33.434",
                        "name": "\u00A0\u00A0\u00A0\u00A0Железнодорожное машиностроение, вагоностроение"
                    },
                    {
                        "id": "33.435",
                        "name": "\u00A0\u00A0\u00A0\u00A0Продукция железнодорожного машиностроения, вагоностроения (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "33.436",
                        "name": "\u00A0\u00A0\u00A0\u00A0Продукция железнодорожного машиностроения, вагоностроения (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "33.437",
                        "name": "\u00A0\u00A0\u00A0\u00A0Судостроение"
                    },
                    {
                        "id": "33.438",
                        "name": "\u00A0\u00A0\u00A0\u00A0Судоремонт"
                    },
                    {
                        "id": "33.439",
                        "name": "\u00A0\u00A0\u00A0\u00A0Продукция судостроения (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "33.440",
                        "name": "\u00A0\u00A0\u00A0\u00A0Производство и ремонт военной техники, оборудования и вооружения"
                    },
                    {
                        "id": "34",
                        "name": "Химическое производство, удобрения",
                    },
                    {
                        "id": "34.416",
                        "name": "\u00A0\u00A0\u00A0\u00A0Агрохимия (производство)"
                    },
                    {
                        "id": "34.417",
                        "name": "\u00A0\u00A0\u00A0\u00A0Агрохимия (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "34.418",
                        "name": "\u00A0\u00A0\u00A0\u00A0Бетон, кирпич, стекло и прочие силикаты (производство)"
                    },
                    {
                        "id": "34.419",
                        "name": "\u00A0\u00A0\u00A0\u00A0Бетон, кирпич, стекло и прочие силикаты (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "34.420",
                        "name": "\u00A0\u00A0\u00A0\u00A0Лакокрасочная продукция, сырье (производство)"
                    },
                    {
                        "id": "34.421",
                        "name": "\u00A0\u00A0\u00A0\u00A0Лакокрасочная продукция, сырье (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "34.422",
                        "name": "\u00A0\u00A0\u00A0\u00A0Неорганическая химия (производство)"
                    },
                    {
                        "id": "34.423",
                        "name": "\u00A0\u00A0\u00A0\u00A0Неорганическая химия (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "34.424",
                        "name": "\u00A0\u00A0\u00A0\u00A0Органическая химия (производство)"
                    },
                    {
                        "id": "34.425",
                        "name": "\u00A0\u00A0\u00A0\u00A0Органическая химия (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "34.426",
                        "name": "\u00A0\u00A0\u00A0\u00A0Резина, пластмасса и прочее (производство)"
                    },
                    {
                        "id": "34.427",
                        "name": "\u00A0\u00A0\u00A0\u00A0Резина, пластмасса и прочее (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "36",
                        "name": "Государственные организации",
                    },
                    {
                        "id": "36.403",
                        "name": "\u00A0\u00A0\u00A0\u00A0Государственные организации"
                    },
                    {
                        "id": "37",
                        "name": "Общественная деятельность, партии, благотворительность, НКО",
                    },
                    {
                        "id": "37.626",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ассоциация в сфере культуры, искусства"
                    },
                    {
                        "id": "37.627",
                        "name": "\u00A0\u00A0\u00A0\u00A0Благотворительная организация"
                    },
                    {
                        "id": "37.628",
                        "name": "\u00A0\u00A0\u00A0\u00A0Общественная, политическая организация"
                    },
                    {
                        "id": "37.629",
                        "name": "\u00A0\u00A0\u00A0\u00A0Профессиональная, предпринимательская организация"
                    },
                    {
                        "id": "37.630",
                        "name": "\u00A0\u00A0\u00A0\u00A0Религиозная организация"
                    },
                    {
                        "id": "37.631",
                        "name": "\u00A0\u00A0\u00A0\u00A0Спортивная федерация"
                    },
                    {
                        "id": "37.632",
                        "name": "\u00A0\u00A0\u00A0\u00A0Фонд, грантодатель"
                    },
                    {
                        "id": "39",
                        "name": "Образовательные учреждения",
                    },
                    {
                        "id": "39.441",
                        "name": "\u00A0\u00A0\u00A0\u00A0Научно-исследовательская, научная, академическая деятельность"
                    },
                    {
                        "id": "39.442",
                        "name": "\u00A0\u00A0\u00A0\u00A0Вуз, ссуз колледж, ПТУ"
                    },
                    {
                        "id": "39.443",
                        "name": "\u00A0\u00A0\u00A0\u00A0Школа, детский сад"
                    },
                    {
                        "id": "39.444",
                        "name": "\u00A0\u00A0\u00A0\u00A0Бизнес-образование"
                    },
                    {
                        "id": "39.445",
                        "name": "\u00A0\u00A0\u00A0\u00A0Повышение квалификации, переквалификация"
                    },
                    {
                        "id": "39.446",
                        "name": "\u00A0\u00A0\u00A0\u00A0Тренинговые компании"
                    },
                    {
                        "id": "39.447",
                        "name": "\u00A0\u00A0\u00A0\u00A0Автошкола"
                    },
                    {
                        "id": "39.448",
                        "name": "\u00A0\u00A0\u00A0\u00A0Обучение иностранным языкам"
                    },
                    {
                        "id": "39.449",
                        "name": "\u00A0\u00A0\u00A0\u00A0Обучение искусствам (рисование, пение, танцы, фото)"
                    },
                    {
                        "id": "39.450",
                        "name": "\u00A0\u00A0\u00A0\u00A0Спортивное обучение"
                    },
                    {
                        "id": "39.451",
                        "name": "\u00A0\u00A0\u00A0\u00A0Интернат, детский дом"
                    },
                    {
                        "id": "41",
                        "name": "Розничная торговля",
                    },
                    {
                        "id": "41.511",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (книги, игрушки, подарки, часы и прочее)"
                    },
                    {
                        "id": "41.512",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (drogerie, товары повседневного спроса)"
                    },
                    {
                        "id": "41.513",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (мебель)"
                    },
                    {
                        "id": "41.514",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (товары для детей)"
                    },
                    {
                        "id": "41.515",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (одежда, обувь, аксессуары)"
                    },
                    {
                        "id": "41.516",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (парфюмерия, косметика)"
                    },
                    {
                        "id": "41.517",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (продуктовая)"
                    },
                    {
                        "id": "41.518",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (DIY и товары для дома)"
                    },
                    {
                        "id": "41.519",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (мобильный ритейл)"
                    },
                    {
                        "id": "41.520",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (спортивные товары)"
                    },
                    {
                        "id": "41.521",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (электроника, бытовая техника)"
                    },
                    {
                        "id": "41.522",
                        "name": "\u00A0\u00A0\u00A0\u00A0Розничная сеть (ювелирные изделия)"
                    },
                    {
                        "id": "41.523",
                        "name": "\u00A0\u00A0\u00A0\u00A0Вендинг (торговля через автоматы)"
                    },
                    {
                        "id": "41.524",
                        "name": "\u00A0\u00A0\u00A0\u00A0Зоомагазин"
                    },
                    {
                        "id": "41.525",
                        "name": "\u00A0\u00A0\u00A0\u00A0Интернет-магазин"
                    },
                    {
                        "id": "41.526",
                        "name": "\u00A0\u00A0\u00A0\u00A0Несетевая розница, мелкий опт"
                    },
                    {
                        "id": "42",
                        "name": "Товары народного потребления (непищевые)",
                    },
                    {
                        "id": "42.589",
                        "name": "\u00A0\u00A0\u00A0\u00A0Бытовая химия, парфюмерия, косметика  (производство)"
                    },
                    {
                        "id": "42.590",
                        "name": "\u00A0\u00A0\u00A0\u00A0Бытовая химия, парфюмерия, косметика  (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.591",
                        "name": "\u00A0\u00A0\u00A0\u00A0Канцтовары, расходные материалы (производство)"
                    },
                    {
                        "id": "42.592",
                        "name": "\u00A0\u00A0\u00A0\u00A0Канцтовары, расходные материалы (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.593",
                        "name": "\u00A0\u00A0\u00A0\u00A0Мебель (производство)"
                    },
                    {
                        "id": "42.594",
                        "name": "\u00A0\u00A0\u00A0\u00A0Мебель (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.595",
                        "name": "\u00A0\u00A0\u00A0\u00A0Одежда, обувь, аксессуары, текстиль (производство)"
                    },
                    {
                        "id": "42.596",
                        "name": "\u00A0\u00A0\u00A0\u00A0Одежда, обувь, аксессуары, текстиль  (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.597",
                        "name": "\u00A0\u00A0\u00A0\u00A0Сантехника (производство)"
                    },
                    {
                        "id": "42.598",
                        "name": "\u00A0\u00A0\u00A0\u00A0Сантехника (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.599",
                        "name": "\u00A0\u00A0\u00A0\u00A0Стройматериалы, сборные конструкции для ремонта и строительства (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.600",
                        "name": "\u00A0\u00A0\u00A0\u00A0Стройматериалы, сборные конструкции для ремонта и строительства (производство, монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "42.601",
                        "name": "\u00A0\u00A0\u00A0\u00A0Спортивные товары и оборудование (производство)"
                    },
                    {
                        "id": "42.602",
                        "name": "\u00A0\u00A0\u00A0\u00A0Спортивные товары и оборудование (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.603",
                        "name": "\u00A0\u00A0\u00A0\u00A0Табак  (производство)"
                    },
                    {
                        "id": "42.604",
                        "name": "\u00A0\u00A0\u00A0\u00A0Табак  (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.605",
                        "name": "\u00A0\u00A0\u00A0\u00A0Посуда, свет, товары для дома  (производство)"
                    },
                    {
                        "id": "42.606",
                        "name": "\u00A0\u00A0\u00A0\u00A0Посуда, свет, товары для дома  (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.607",
                        "name": "\u00A0\u00A0\u00A0\u00A0Товары для детей (производство)"
                    },
                    {
                        "id": "42.608",
                        "name": "\u00A0\u00A0\u00A0\u00A0Товары для детей (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "42.609",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ювелирные изделия, бижутерия  (производство)"
                    },
                    {
                        "id": "42.610",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ювелирные изделия, бижутерия  (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "43",
                        "name": "Финансовый сектор",
                    },
                    {
                        "id": "43.641",
                        "name": "\u00A0\u00A0\u00A0\u00A0Аудит, управленческий учет, финансово-юридический консалтинг"
                    },
                    {
                        "id": "43.642",
                        "name": "\u00A0\u00A0\u00A0\u00A0Услуги по ведению бухгалтерского и налогового учета, расчет заработной платы"
                    },
                    {
                        "id": "43.643",
                        "name": "\u00A0\u00A0\u00A0\u00A0Коллекторская деятельность"
                    },
                    {
                        "id": "43.644",
                        "name": "\u00A0\u00A0\u00A0\u00A0Лизинговые компании"
                    },
                    {
                        "id": "43.645",
                        "name": "\u00A0\u00A0\u00A0\u00A0НПФ"
                    },
                    {
                        "id": "43.646",
                        "name": "\u00A0\u00A0\u00A0\u00A0Страхование, перестрахование"
                    },
                    {
                        "id": "43.647",
                        "name": "\u00A0\u00A0\u00A0\u00A0Банк"
                    },
                    {
                        "id": "43.648",
                        "name": "\u00A0\u00A0\u00A0\u00A0Управляющая, инвестиционная компания (управление активами)"
                    },
                    {
                        "id": "43.649",
                        "name": "\u00A0\u00A0\u00A0\u00A0Факторинговые компании"
                    },
                    {
                        "id": "43.650",
                        "name": "\u00A0\u00A0\u00A0\u00A0Финансово-кредитное посредничество (биржа, брокерская деятельность, выпуск и обслуживание карт, оценка рисков, обменные пункты, агентства по кредитованию, инкассация, ломбард, платежные системы)"
                    },
                    {
                        "id": "44",
                        "name": "Услуги для бизнеса",
                    },
                    {
                        "id": "44.390",
                        "name": "\u00A0\u00A0\u00A0\u00A0Безопасность, охранная деятельность"
                    },
                    {
                        "id": "44.391",
                        "name": "\u00A0\u00A0\u00A0\u00A0Кадровые агентства"
                    },
                    {
                        "id": "44.392",
                        "name": "\u00A0\u00A0\u00A0\u00A0Колл-центры, диспетчерские службы"
                    },
                    {
                        "id": "44.393",
                        "name": "\u00A0\u00A0\u00A0\u00A0Консалтинговые услуги"
                    },
                    {
                        "id": "44.394",
                        "name": "\u00A0\u00A0\u00A0\u00A0Переводческая деятельность"
                    },
                    {
                        "id": "44.395",
                        "name": "\u00A0\u00A0\u00A0\u00A0Экологическое обслуживание, водоочистка, утилизация отходов"
                    },
                    {
                        "id": "44.396",
                        "name": "\u00A0\u00A0\u00A0\u00A0Услуги по организации поездок и бронированию"
                    },
                    {
                        "id": "44.397",
                        "name": "\u00A0\u00A0\u00A0\u00A0Контроль качества, экспертиза, испытания и сертификация"
                    },
                    {
                        "id": "44.398",
                        "name": "\u00A0\u00A0\u00A0\u00A0Юридическое обслуживание"
                    },
                    {
                        "id": "45",
                        "name": "Добывающая отрасль",
                    },
                    {
                        "id": "45.534",
                        "name": "\u00A0\u00A0\u00A0\u00A0Добыча и обогащение угля"
                    },
                    {
                        "id": "45.535",
                        "name": "\u00A0\u00A0\u00A0\u00A0Добыча и обогащение руд черных, цветных, драгоценных, благородных, редких металлов"
                    },
                    {
                        "id": "45.536",
                        "name": "\u00A0\u00A0\u00A0\u00A0Добыча и обогащение минерального сырья (соль, сера, глинозем), разработка карьеров (песок, глина, камень), добыча торфа"
                    },
                    {
                        "id": "45.537",
                        "name": "\u00A0\u00A0\u00A0\u00A0Инженерно-изыскательские, гидрогеологические, геологоразведочные работы"
                    },
                    {
                        "id": "46",
                        "name": "Энергетика",
                    },
                    {
                        "id": "46.469",
                        "name": "\u00A0\u00A0\u00A0\u00A0Атомная энергетика (генерация электроэнергии, АЭС)"
                    },
                    {
                        "id": "46.470",
                        "name": "\u00A0\u00A0\u00A0\u00A0Гидроэнергетика (генерация электроэнергии, ГЭС)"
                    },
                    {
                        "id": "46.471",
                        "name": "\u00A0\u00A0\u00A0\u00A0Теплоэнергетика (генерация электроэнергии и тепла, ТЭС)"
                    },
                    {
                        "id": "46.472",
                        "name": "\u00A0\u00A0\u00A0\u00A0Альтернативная энергетика: гео-, ветро-, солнце-, био- (генерация электроэнергии)"
                    },
                    {
                        "id": "46.473",
                        "name": "\u00A0\u00A0\u00A0\u00A0Передача, распределение электроэнергии"
                    },
                    {
                        "id": "46.474",
                        "name": "\u00A0\u00A0\u00A0\u00A0Сбыт и потребление электроэнергии"
                    },
                    {
                        "id": "46.475",
                        "name": "\u00A0\u00A0\u00A0\u00A0Теплоснабжение (ТЭЦ)"
                    },
                    {
                        "id": "46.476",
                        "name": "\u00A0\u00A0\u00A0\u00A0Инфраструктурная компания в энергетике (СО ЕЭС, АТС, ЦФР и т.п.)"
                    },
                    {
                        "id": "46.477",
                        "name": "\u00A0\u00A0\u00A0\u00A0Консалтинг в области энергоэффективности"
                    },
                    {
                        "id": "47",
                        "name": "Нефть и газ",
                    },
                    {
                        "id": "47.611",
                        "name": "\u00A0\u00A0\u00A0\u00A0Добыча нефти"
                    },
                    {
                        "id": "47.612",
                        "name": "\u00A0\u00A0\u00A0\u00A0Нефтепереработка, нефтехимия (производство)"
                    },
                    {
                        "id": "47.613",
                        "name": "\u00A0\u00A0\u00A0\u00A0Транспортировка, хранение нефти"
                    },
                    {
                        "id": "47.614",
                        "name": "\u00A0\u00A0\u00A0\u00A0Нефтехимия (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "47.615",
                        "name": "\u00A0\u00A0\u00A0\u00A0ГСМ, топливо (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "47.616",
                        "name": "\u00A0\u00A0\u00A0\u00A0ГСМ, топливо (розничная торговля)"
                    },
                    {
                        "id": "47.617",
                        "name": "\u00A0\u00A0\u00A0\u00A0Добыча газа"
                    },
                    {
                        "id": "47.618",
                        "name": "\u00A0\u00A0\u00A0\u00A0Переработка газа"
                    },
                    {
                        "id": "47.619",
                        "name": "\u00A0\u00A0\u00A0\u00A0Транспортировка, хранение газа"
                    },
                    {
                        "id": "48",
                        "name": "Медицина, фармацевтика, аптеки",
                    },
                    {
                        "id": "48.676",
                        "name": "\u00A0\u00A0\u00A0\u00A0Аптека, оптика"
                    },
                    {
                        "id": "48.677",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ветеринарная аптека"
                    },
                    {
                        "id": "48.678",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ветеринарная деятельность"
                    },
                    {
                        "id": "48.679",
                        "name": "\u00A0\u00A0\u00A0\u00A0Клинические исследования"
                    },
                    {
                        "id": "48.680",
                        "name": "\u00A0\u00A0\u00A0\u00A0Лаборатория, исследовательский центр"
                    },
                    {
                        "id": "48.681",
                        "name": "\u00A0\u00A0\u00A0\u00A0Лечебно-профилактические учреждения"
                    },
                    {
                        "id": "48.682",
                        "name": "\u00A0\u00A0\u00A0\u00A0Учреждение соц.помощи и защиты"
                    },
                    {
                        "id": "48.683",
                        "name": "\u00A0\u00A0\u00A0\u00A0Фармацевтическая продукция (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "48.684",
                        "name": "\u00A0\u00A0\u00A0\u00A0Фармацевтическая продукция (производство)"
                    },
                    {
                        "id": "49",
                        "name": "Услуги для населения",
                    },
                    {
                        "id": "49.404",
                        "name": "\u00A0\u00A0\u00A0\u00A0Аренда автомобилей"
                    },
                    {
                        "id": "49.405",
                        "name": "\u00A0\u00A0\u00A0\u00A0Домашний персонал"
                    },
                    {
                        "id": "49.406",
                        "name": "\u00A0\u00A0\u00A0\u00A0Игорный бизнес"
                    },
                    {
                        "id": "49.407",
                        "name": "\u00A0\u00A0\u00A0\u00A0Пошив, ремонт одежды и обуви"
                    },
                    {
                        "id": "49.408",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ритуальные услуги"
                    },
                    {
                        "id": "49.409",
                        "name": "\u00A0\u00A0\u00A0\u00A0Салоны красоты"
                    },
                    {
                        "id": "49.410",
                        "name": "\u00A0\u00A0\u00A0\u00A0Спортивные и фитнес-клубы"
                    },
                    {
                        "id": "49.411",
                        "name": "\u00A0\u00A0\u00A0\u00A0Такси"
                    },
                    {
                        "id": "49.412",
                        "name": "\u00A0\u00A0\u00A0\u00A0Туристические компании"
                    },
                    {
                        "id": "49.413",
                        "name": "\u00A0\u00A0\u00A0\u00A0Фото- и видеоуслуги"
                    },
                    {
                        "id": "49.414",
                        "name": "\u00A0\u00A0\u00A0\u00A0Химчистка"
                    },
                    {
                        "id": "49.415",
                        "name": "\u00A0\u00A0\u00A0\u00A0Центры развлечения"
                    },
                    {
                        "id": "50",
                        "name": "Гостиницы, рестораны, общепит, кейтеринг",
                    },
                    {
                        "id": "50.527",
                        "name": "\u00A0\u00A0\u00A0\u00A0Гостиница"
                    },
                    {
                        "id": "50.528",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ресторан, общественное питание, фаст-фуд"
                    },
                    {
                        "id": "50.529",
                        "name": "\u00A0\u00A0\u00A0\u00A0Кейтеринг (выездное обслуживание)"
                    },
                    {
                        "id": "51",
                        "name": "ЖКХ",
                    },
                    {
                        "id": "51.667",
                        "name": "\u00A0\u00A0\u00A0\u00A0Вентиляция и кондиционирование (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "51.668",
                        "name": "\u00A0\u00A0\u00A0\u00A0Водоснабжение и канализация"
                    },
                    {
                        "id": "51.669",
                        "name": "\u00A0\u00A0\u00A0\u00A0Лифтовое хозяйство (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "51.670",
                        "name": "\u00A0\u00A0\u00A0\u00A0Обеспечение пожарной безопасности, молниезащиты"
                    },
                    {
                        "id": "51.671",
                        "name": "\u00A0\u00A0\u00A0\u00A0Благоустройство и уборка территорий и зданий"
                    },
                    {
                        "id": "51.672",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ремонт зданий и сооружений"
                    },
                    {
                        "id": "51.673",
                        "name": "\u00A0\u00A0\u00A0\u00A0Слаботочные сети (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "51.674",
                        "name": "\u00A0\u00A0\u00A0\u00A0Утилизация бытовых отходов"
                    },
                    {
                        "id": "51.675",
                        "name": "\u00A0\u00A0\u00A0\u00A0Энергоснабжение"
                    },
                    {
                        "id": "52",
                        "name": "Искусство, культура",
                    },
                    {
                        "id": "52.651",
                        "name": "\u00A0\u00A0\u00A0\u00A0Архив, библиотека, искусствоведение"
                    },
                    {
                        "id": "52.652",
                        "name": "\u00A0\u00A0\u00A0\u00A0Ботанический сад, зоопарк, заповедник"
                    },
                    {
                        "id": "52.653",
                        "name": "\u00A0\u00A0\u00A0\u00A0Музей, галерея, театр"
                    },
                    {
                        "id": "388",
                        "name": "Промышленное оборудование, техника, станки и комплектующие",
                    },
                    {
                        "id": "388.487",
                        "name": "\u00A0\u00A0\u00A0\u00A0Медицинское, диагностическое оборудование, инструменты (производство)"
                    },
                    {
                        "id": "388.488",
                        "name": "\u00A0\u00A0\u00A0\u00A0Медицинское, диагностическое оборудование, инструменты (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "388.489",
                        "name": "\u00A0\u00A0\u00A0\u00A0Медицинское, диагностическое оборудование, инструменты (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "388.490",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование для ресторанов, гостиниц, кейтеринга, розничной торговли (производство)"
                    },
                    {
                        "id": "388.491",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование для ресторанов, гостиниц, кейтеринга, розничной торговли  (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "388.492",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование для ресторанов, гостиниц, кейтеринга, розничной торговли  (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "388.493",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование для пищевой промышленности, упаковки и хранения (производство)"
                    },
                    {
                        "id": "388.494",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование для пищевой промышленности, упаковки и хранения (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "388.495",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование для пищевой промышленности, упаковки и хранения (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "388.496",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование и станки для отраслей легкой промышленности (производство)"
                    },
                    {
                        "id": "388.497",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование и станки для отраслей легкой промышленности (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "388.498",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование и станки для отраслей легкой промышленности (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "388.499",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование и станки для добывающей, энергетической, нефтегазовой и химической отрасли  (производство)"
                    },
                    {
                        "id": "388.500",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование и станки для добывающей, энергетической, нефтегазовой и химической отрасли  (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "388.501",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование и станки для добывающей, энергетической, нефтегазовой и химической отрасли  (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "388.502",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование и станки для металлургии и металлообработки (производство)"
                    },
                    {
                        "id": "388.503",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование и станки для металлургии и металлообработки (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "388.504",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование и станки для металлургии и металлообработки (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "388.505",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование для деревообработки, заготовки леса, целлюлозно-бумажной промышленности (производство)"
                    },
                    {
                        "id": "388.506",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование для деревообработки, заготовки леса, целлюлозно-бумажной промышленности (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "388.507",
                        "name": "\u00A0\u00A0\u00A0\u00A0Оборудование для деревообработки, заготовки леса, целлюлозно-бумажной промышленности (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "388.508",
                        "name": "\u00A0\u00A0\u00A0\u00A0Дорожно-строительная техника, сельскохозяйственная и другая спец.техника, оборудование, лифты, погрузочно-разгрузочное, складское оборудование (производство)"
                    },
                    {
                        "id": "388.509",
                        "name": "\u00A0\u00A0\u00A0\u00A0Дорожно-строительная техника, сельскохозяйственная и другая спец.техника, оборудование, лифты, погрузочно-разгрузочное, складское оборудование (монтаж, сервис, ремонт)"
                    },
                    {
                        "id": "388.510",
                        "name": "\u00A0\u00A0\u00A0\u00A0Дорожно-строительная техника, сельскохозяйственная и другая спец.техника, оборудование, лифты, погрузочно-разгрузочное, складское оборудование (продвижение, оптовая торговля)"
                    },
                    {
                        "id": "389",
                        "name": "Управление многопрофильными активами",
                    },
                    {
                        "id": "389.530",
                        "name": "\u00A0\u00A0\u00A0\u00A0Управляющая компания группы, холдинга, штаб-квартира"
                    }
                ],
                period: [
                    {
                        "id": "all_time",
                        "name": "За все время",
                    },
                    {
                        "id": "last_year",
                        "name": "За последний год",
                    },
                    {
                        "id": "last_three_years",
                        "name": "За последние 3 года",
                    },
                    {
                        "id": "last_six_years",
                        "name": "За последние 6 лет",
                    },
                ],
            },
            hide: false,
            language: {
                language: [
                    {
                        id: "eng",
                        name: "Английский",
                    },
                    {
                        id: "deu",
                        name: "Немецкий",
                    },
                    {
                        id: "fra",
                        name: "Французский",
                    },
                    {
                        id: "abq",
                        name: "Абазинский",
                    },
                    {
                        id: "abk",
                        name: "Абхазский",
                    },
                    {
                        id: "ava",
                        name: "Аварский",
                    },
                    {
                        id: "aze",
                        name: "Азербайджанский",
                    },
                    {
                        id: "sqi",
                        name: "Албанский",
                    },
                    {
                        id: "amh",
                        name: "Амхарский",
                    },
                    {
                        id: "ara",
                        name: "Арабский",
                    },
                    {
                        id: "hye",
                        name: "Армянский",
                    },
                    {
                        id: "afr",
                        name: "Африкаанс",
                    },
                    {
                        id: "eus",
                        name: "Баскский",
                    },
                    {
                        id: "bak",
                        name: "Башкирский",
                    },
                    {
                        id: "bel",
                        name: "Белорусский",
                    },
                    {
                        id: "ben",
                        name: "Бенгальский",
                    },
                    {
                        id: "mya",
                        name: "Бирманский",
                    },
                    {
                        id: "bul",
                        name: "Болгарский",
                    },
                    {
                        id: "bos",
                        name: "Боснийский",
                    },
                    {
                        id: "bua",
                        name: "Бурятский",
                    },
                    {
                        id: "hun",
                        name: "Венгерский",
                    },
                    {
                        id: "vie",
                        name: "Вьетнамский",
                    },
                    {
                        id: "nld",
                        name: "Голландский",
                    },
                    {
                        id: "ell",
                        name: "Греческий",
                    },
                    {
                        id: "kat",
                        name: "Грузинский",
                    },
                    {
                        id: "dag",
                        name: "Дагестанский",
                    },
                    {
                        id: "dar",
                        name: "Даргинский",
                    },
                    {
                        id: "dan",
                        name: "Датский",
                    },
                    {
                        id: "heb",
                        name: "Иврит",
                    },
                    {
                        id: "inh",
                        name: "Ингушский",
                    },
                    {
                        id: "ind",
                        name: "Индонезийский",
                    },
                    {
                        id: "gle",
                        name: "Ирландский",
                    },
                    {
                        id: "isl",
                        name: "Исландский",
                    },
                    {
                        id: "spa",
                        name: "Испанский",
                    },
                    {
                        id: "ita",
                        name: "Итальянский",
                    },
                    {
                        id: "kbd",
                        name: "Кабардино-черкесский",
                    },
                    {
                        id: "kaz",
                        name: "Казахский",
                    },
                    {
                        id: "krc",
                        name: "Карачаево-балкарский",
                    },
                    {
                        id: "krl",
                        name: "Карельский",
                    },
                    {
                        id: "cat",
                        name: "Каталанский",
                    },
                    {
                        id: "kas",
                        name: "Кашмирский",
                    },
                    {
                        id: "zho",
                        name: "Китайский",
                    },
                    {
                        id: "kom",
                        name: "Коми",
                    },
                    {
                        id: "kor",
                        name: "Корейский",
                    },
                    {
                        id: "crs",
                        name: "Креольский (Сейшельские острова)",
                    },
                    {
                        id: "kum",
                        name: "Кумыкский",
                    },
                    {
                        id: "kur",
                        name: "Курдский",
                    },
                    {
                        id: "khm",
                        name: "Кхмерский (Камбоджийский)",
                    },
                    {
                        id: "kir",
                        name: "Кыргызский",
                    },
                    {
                        id: "lbe",
                        name: "Лакский",
                    },
                    {
                        id: "lao",
                        name: "Лаосский",
                    },
                    {
                        id: "lat",
                        name: "Латинский",
                    },
                    {
                        id: "lav",
                        name: "Латышский",
                    },
                    {
                        id: "lez",
                        name: "Лезгинский",
                    },
                    {
                        id: "lit",
                        name: "Литовский",
                    },
                    {
                        id: "mke",
                        name: "Македонский",
                    },
                    {
                        id: "zlm",
                        name: "Малазийский",
                    },
                    {
                        id: "mns",
                        name: "Мансийский",
                    },
                    {
                        id: "chm",
                        name: "Марийский",
                    },
                    {
                        id: "mon",
                        name: "Монгольский",
                    },
                    {
                        id: "nep",
                        name: "Непальский",
                    },
                    {
                        id: "nog",
                        name: "Ногайский",
                    },
                    {
                        id: "nor",
                        name: "Норвежский",
                    },
                    {
                        id: "oss",
                        name: "Осетинский",
                    },
                    {
                        id: "pan",
                        name: "Панджаби",
                    },
                    {
                        id: "fas",
                        name: "Персидский",
                    },
                    {
                        id: "pol",
                        name: "Польский",
                    },
                    {
                        id: "por",
                        name: "Португальский",
                    },
                    {
                        id: "pus",
                        name: "Пушту",
                    },
                    {
                        id: "ron",
                        name: "Румынский",
                    },
                    {
                        id: "rus",
                        name: "Русский",
                    },
                    {
                        id: "san",
                        name: "Санскрит",
                    },
                    {
                        id: "srp",
                        name: "Сербский",
                    },
                    {
                        id: "slk",
                        name: "Словацкий",
                    },
                    {
                        id: "slv",
                        name: "Словенский",
                    },
                    {
                        id: "som",
                        name: "Сомалийский",
                    },
                    {
                        id: "swa",
                        name: "Суахили",
                    },
                    {
                        id: "tgl",
                        name: "Тагальский",
                    },
                    {
                        id: "tgk",
                        name: "Таджикский",
                    },
                    {
                        id: "tha",
                        name: "Тайский",
                    },
                    {
                        id: "tly",
                        name: "Талышский",
                    },
                    {
                        id: "tam",
                        name: "Тамильский",
                    },
                    {
                        id: "tat",
                        name: "Татарский",
                    },
                    {
                        id: "bod",
                        name: "Тибетский",
                    },
                    {
                        id: "tyv",
                        name: "Тувинский",
                    },
                    {
                        id: "tur",
                        name: "Турецкий",
                    },
                    {
                        id: "tuk",
                        name: "Туркменский",
                    },
                    {
                        id: "udm",
                        name: "Удмуртский",
                    },
                    {
                        id: "uzb",
                        name: "Узбекский",
                    },
                    {
                        id: "uig",
                        name: "Уйгурский",
                    },
                    {
                        id: "ukr",
                        name: "Украинский",
                    },
                    {
                        id: "urd",
                        name: "Урду",
                    },
                    {
                        id: "fin",
                        name: "Финский",
                    },
                    {
                        id: "vls",
                        name: "Фламандский",
                    },
                    {
                        id: "hin",
                        name: "Хинди",
                    },
                    {
                        id: "hrv",
                        name: "Хорватский",
                    },
                    {
                        id: "che",
                        name: "Чеченский",
                    },
                    {
                        id: "ces",
                        name: "Чешский",
                    },
                    {
                        id: "chv",
                        name: "Чувашский",
                    },
                    {
                        id: "swe",
                        name: "Шведский",
                    },
                    {
                        id: "epo",
                        name: "Эсперанто",
                    },
                    {
                        id: "est",
                        name: "Эстонский",
                    },
                    {
                        id: "sah",
                        name: "Якутский",
                    },
                    {
                        id: "jpn",
                        name: "Японский",
                    },
                ],
                level: [
                    {
                        id: "a1",
                        name: "A1 — Начальный"
                    },
                    {
                        id: "a2",
                        name: "A2 — Элементарный"
                    },
                    {
                        id: "b1",
                        name: "B1 — Средний"
                    },
                    {
                        id: "b2",
                        name: "B2 — Средне-продвинутый"
                    },
                    {
                        id: "c1",
                        name: "C1 — Продвинутый"
                    },
                    {
                        id: "c2",
                        name: "C2 — В совершенстве"
                    },
                    {
                        id: "l1",
                        name: "Родной"
                    },
                ],
            },
            lightbox: false,
            metro: [],
            options: {
                data: {
                    area: false,
                    education_primary: false,
                    experience: false,
                    experience_last: true,
                    experience_total: true,
                    image: true,
                    updated_at: true,
                    hide: false,
                },
                progress: false,
                show: false,
            },
            photo: [],
            query_fields: [
                {
                    id: 'everywhere',
                    name: 'Везде',
                },
                {
                    id: 'title',
                    name: 'В названии резюме',
                },
                {
                    id: 'education',
                    name: 'В образовании',
                },
                {
                    id: 'skills',
                    name: 'В ключевых навыках',
                },
                {
                    id: 'experience',
                    name: 'В опыте работы',
                    children: [
                        {
                            id: 'experience_company',
                            name: 'В компаниях и отраслях',
                        },
                        {
                            id: 'experience_position',
                            name: 'В должностях',
                        },
                        {
                            id: 'experience_description',
                            name: 'В обязанностях',
                        },
                    ],
                },
            ],
            pages: 1,
            progress: false,
            queries: 1,
            relocation: {
                data: [
                    {
                        id: 'living_or_relocation',
                        name: 'Живут в указанном регионе или готовы переехать в него',
                    },
                    {
                        id: 'living',
                        name: 'Живут в указанном регионе',
                    },
                    {
                        id: 'living_but_relocation',
                        name: 'Живут в указанном регионе и готовы к переезду куда-либо',
                    },
                    {
                        id: 'relocation',
                        name: 'Не живут в указанном регионе, но готовы переехать в него',
                    },
                ],
            },
            resume: [],
            searchError: '',
            show: false,
            skills: { items: [], popular: [], loading: false, error: '', request: 0 },
            specialization: {
                data: [],
                show: false,
                loading: false,
                error: '',
            },
            temp: {
                citizenship: '',
                metro: '',
                work_ticket: '',
            },
            wait: false,
            warning: false,
            world: {
                data: [],
                loading: false,
                error: '',
                show: false,
            },
        }
    },
    computed: {
        institutionItems () {
            const selectedIds = new Set(this.data.educational_institution.map(item => String(item.id)))
            return [...this.data.educational_institution, ...this.institution.items.filter(item => !selectedIds.has(String(item.id)))]
        },
        industriesSelected () {
            return this.exp.industry.filter(industry => this.data.filter_exp_industry.includes(industry.id))
                .map(industry => ({ ...industry, name: industry.name.trim() }))
        },
        citizenshipSelected () {
            return this.country.data.filter(c => {return this.data.citizenship.includes(c.hh_id)})
        },
        metroByCity () {
            if (this.data.areas.length !== 1) {
                return []
            }
            const area = this.world.data.find(area => area.id === this.data.areas[0])
            return area ? this.metro.filter(m => m.city_id === area.local_id) : []
        },
        metroSelected () {
            return this.metro.filter(m => {return this.data.metro.includes(m.hh_id)})
        },
        specializationSelected () {
            const selected = new Set(this.data.specialization)
            return this.specialization.data.filter(item => selected.has(item.id)
                && (item.parent_id === null || !selected.has(item.parent_id)))
        },
        user () {
            return this.$store.getters.user
        },
        workTicketSelected () {
            return this.country.data.filter(c => {return this.data.work_ticket.includes(c.hh_id)})
        },
        worldSelected () {
            return this.world.data.filter(w => this.data.areas.includes(w.id))
        },
    },
    watch: {
        'autocomplete1.search' (query) {
            query && query !== this.data.query1 && query.length > 1 && this.autosuggest1(query)
        },
        'autocomplete2.search' (query) {
            query && query !== this.data.query2 && query.length > 1 && this.autosuggest2(query)
        },
        'autocomplete3.search' (query) {
            query && query !== this.data.query3 && query.length > 1 && this.autosuggest3(query)
        },
        'data.page' () {
            if (!this.savedSearch.restoring) this.searchResume()
        },
        '$route.query.savedSearch' () {
            this.loadSavedSearch()
        },
        'data.query1_fields' (newFields, oldFields) {
            if (newFields.indexOf('everywhere') !== -1 && oldFields.indexOf('everywhere') === -1 && newFields.length > 1) {
                this.data.query1_fields = ['everywhere']
            }
            if (oldFields.indexOf('everywhere') !== -1 && newFields.indexOf('everywhere') !== -1 && newFields.length > 1) {
                this.data.query1_fields = newFields.filter(f => {return f !== 'everywhere'})
            }
            if (newFields.length === 0) {
                this.data.query1_fields = ['everywhere']
            }
        },
        'data.query2_fields' (newFields, oldFields) {
            if (newFields.indexOf('everywhere') !== -1 && oldFields.indexOf('everywhere') === -1 && newFields.length > 1) {
                this.data.query2_fields = ['everywhere']
            }
            if (oldFields.indexOf('everywhere') !== -1 && newFields.indexOf('everywhere') !== -1 && newFields.length > 1) {
                this.data.query2_fields = newFields.filter(f => {return f !== 'everywhere'})
            }
            if (newFields.length === 0) {
                this.data.query2_fields = ['everywhere']
            }
        },
        'data.query3_fields' (newFields, oldFields) {
            if (newFields.indexOf('everywhere') !== -1 && oldFields.indexOf('everywhere') === -1 && newFields.length > 1) {
                this.data.query3_fields = ['everywhere']
            }
            if (oldFields.indexOf('everywhere') !== -1 && newFields.indexOf('everywhere') !== -1 && newFields.length > 1) {
                this.data.query3_fields = newFields.filter(f => {return f !== 'everywhere'})
            }
            if (newFields.length === 0) {
                this.data.query3_fields = ['everywhere']
            }
        },
        'institution.search' (query) {
            clearTimeout(this.institution.timer)
            this.institution.error = ''
            this.institution.request++
            this.institution.items = []
            if ((query || '').trim().length < 2) {
                this.institution.loading = false
                return
            }
            this.institution.timer = setTimeout(() => this.autosuggestEducation(query), 250)
        },
        'data.period' (period) {
            if (period !== 'interval') { this.data.date_from = ''; this.data.date_to = '' }
        },
        'data.employment_form' () { if (!this.savedSearch.restoring) this.data.employment = [] },
        'data.work_format' () { if (!this.savedSearch.restoring) this.data.schedule = [] },
    },
    beforeDestroy () { clearTimeout(this.institution.timer) },
    created () {
        this.searchDictionaries()
        this.autosuggestSkill('')
        this.searchOptions()
        this.searchMetro()
        this.searchSpecialization()
        this.searchCountry()
        this.searchWorld()
        this.loadSavedSearch()
    },
    methods: {
        openSaveSearch () {
            this.savedSearch.filters = savedSearchFilters(this.data)
            this.savedSearch.summary = summarizeSearchFilters(this.data, this)
            this.savedSearch.saveError = ''
            this.savedSearch.nameErrors = []
            this.savedSearch.show = true
        },
        saveSearch (name) {
            if (this.savedSearch.saving) return
            this.savedSearch.saving = true
            this.savedSearch.saveError = ''
            this.savedSearch.nameErrors = []
            return this.$axios.post('/console/saved-search/create', {
                name,
                filters: this.savedSearch.filters,
                summary: this.savedSearch.summary,
            }).then(res => {
                if (res.data.success) {
                    this.savedSearch.show = false
                    this.savedSearch.success = true
                } else {
                    this.savedSearch.nameErrors = res.data.errors.name || []
                    if (!this.savedSearch.nameErrors.length) this.savedSearch.saveError = 'Не удалось сохранить поиск. Проверьте выбранные фильтры.'
                }
            }).catch(() => {
                this.savedSearch.saveError = 'Не удалось сохранить поиск. Повторите попытку.'
            }).finally(() => { this.savedSearch.saving = false })
        },
        loadSavedSearch () {
            const id = this.$route.query.savedSearch
            this.savedSearch.error = ''
            if (!id) {
                this.savedSearch.loading = false
                return
            }
            this.savedSearch.loading = true
            return this.$axios.post('/console/saved-search/view', {id}).then(async res => {
                if (this.$route.query.savedSearch !== id) return
                if (!res.data.success) {
                    this.savedSearch.error = 'Сохранённый поиск не найден.'
                    return
                }
                this.savedSearch.restoring = true
                this.data = restoreSearchFilters(res.data.data.filters)
                this.institution.items = [...this.data.educational_institution]
                this.queries = this.data.query3 ? 3 : this.data.query2 ? 2 : 1
                this.hide = false
                this.resume = []
                this.pages = 1
                await this.$nextTick()
                this.savedSearch.restoring = false
                if (this.$route.query.savedSearch !== id) return
                if (this.$moment(this.user.accessTill).diff(this.$moment(), 'minutes') > 0
                    && (this.user.resumeBasicLimit > 0 || this.user.resumeExtraLimit > 0)
                    && this.user.accessSchedule === 'allow') this.searchResume()
            }).catch(() => {
                if (this.$route.query.savedSearch === id) this.savedSearch.error = 'Не удалось загрузить сохранённый поиск. Повторите попытку.'
            }).finally(() => {
                if (this.$route.query.savedSearch === id) this.savedSearch.loading = false
            })
        },
        submitSearch () {
            if (this.savedSearch.loading || this.progress) return
            if (this.data.page !== 1) this.data.page = 1
            else this.searchResume()
        },
        removeIndustry (id) {
            this.data.filter_exp_industry = this.data.filter_exp_industry.filter(value => value !== id)
        },

        // Методы для работы с языками
        addLanguage() {
            if (this.newLanguage.language_id && this.newLanguage.level_id) {
                // Проверяем, не добавлен ли уже такой язык
                const exists = this.data.languages.some(
                    lang => lang.language_id === this.newLanguage.language_id && lang.level_id === this.newLanguage.level_id
                );

                if (!exists) {
                    this.data.languages.push({
                        language_id: this.newLanguage.language_id,
                        level_id: this.newLanguage.level_id
                    });
                }

                // Очищаем форму
                this.newLanguage.language_id = '';
                this.newLanguage.level_id = '';
            }
        },

        removeLanguage(index) {
            this.data.languages.splice(index, 1);
        },

        getLanguageName(languageId) {
            const lang = this.language.language.find(l => l.id === languageId);
            return lang ? lang.name : languageId;
        },

        getLanguageLevelName(levelId) {
            const level = this.language.level.find(l => l.id === levelId);
            return level ? level.name : levelId;
        },

        autosuggest1 (term) {
            this.autocomplete1.loading = true

            return this.$axios.post('/console/search/autosuggest', {term: term})
                .then(res => {
                    if (res.data.success) {
                        this.autocomplete1.items = res.data.data
                    }

                    this.autocomplete1.loading = false
                })
                .catch(error => {
                    this.autocomplete1.loading = false
                    this.showSearchError(error)
                })
        },

        autosuggest2 (term) {
            this.autocomplete2.loading = true

            return this.$axios.post('/console/search/autosuggest', {term: term})
                .then(res => {
                    if (res.data.success) {
                        this.autocomplete2.items = res.data.data
                    }

                    this.autocomplete2.loading = false
                })
                .catch(error => {
                    this.autocomplete2.loading = false
                    this.showSearchError(error)
                })
        },

        autosuggest3 (term) {
            this.autocomplete3.loading = true

            return this.$axios.post('/console/search/autosuggest', {term: term})
                .then(res => {
                    if (res.data.success) {
                        this.autocomplete3.items = res.data.data
                    }

                    this.autocomplete3.loading = false
                })
                .catch(error => {
                    this.autocomplete3.loading = false
                    this.showSearchError(error)
                })
        },

        autosuggestSkill (term) {
            term = (term || '').trim()
            const request = ++this.skills.request
            this.skills.error = ''
            if (term.length === 1) {
                this.skills.items = [...this.skills.popular]
                this.skills.loading = false
                return Promise.resolve()
            }
            this.skills.loading = true
            return this.$axios.post('/console/search/autosuggest/skill', {term}).then(res => {
                if (request !== this.skills.request) return
                if (!res.data.success) throw new Error('suggestions')
                this.skills.items = res.data.data
                if (!term) this.skills.popular = [...res.data.data]
            }).catch(() => {
                if (request === this.skills.request) this.skills.error = 'Не удалось загрузить навыки.'
            }).finally(() => { if (request === this.skills.request) this.skills.loading = false })
        },
        autosuggestEducation (term) {
            const request = ++this.institution.request
            this.institution.loading = true
            this.institution.error = ''
            return this.$axios.post('/console/search/autosuggest/education', {term}).then(res => {
                if (request !== this.institution.request) return
                if (!res.data.success) throw new Error('suggestions')
                this.institution.items = res.data.data
            }).catch(() => {
                if (request === this.institution.request) this.institution.error = 'Не удалось загрузить учебные заведения. Повторите поиск.'
            }).finally(() => { if (request === this.institution.request) this.institution.loading = false })
        },
        searchDictionaries () {
            this.filterDictionaries.loading = true
            this.filterDictionaries.error = ''
            return this.$axios.post('/console/search/dictionaries').then(res => {
                if (!res.data.success) throw new Error('dictionaries')
                this.filterDictionaries.data = res.data.data
                const trips = res.data.data.business_trip_readiness
                this.business_trip_readiness.data = [...trips.filter(item => item.id === 'never'), ...trips.filter(item => item.id !== 'never')]
            }).catch(() => { this.filterDictionaries.error = 'Не удалось загрузить варианты фильтров.' })
                .finally(() => { this.filterDictionaries.loading = false })
        },
        legacyFilterNames (field) {
            const names = field === 'employment'
                ? { full: 'Полная занятость', part: 'Частичная занятость', project: 'Проектная работа', volunteer: 'Волонтёрство', probation: 'Стажировка' }
                : { fullDay: 'Полный день', shift: 'Сменный график', flexible: 'Гибкий график', remote: 'Удалённая работа', flyInFlyOut: 'Вахтовый метод' }
            return this.data[field].map(id => names[id] || id).join(', ')
        },
        institutionName (item) {
            return item.acronym || item.text
        },
        sizeInstitutionMenu () {
            const autocomplete = this.$refs.institutionAutocomplete
            if (autocomplete) this.institution.menuWidth = autocomplete.$el.getBoundingClientRect().width
        },
        selectInstitution (items) {
            const added = items.some(item => !this.data.educational_institution.some(selected => String(selected.id) === String(item.id)))
            this.data.educational_institution = items
            if (added) this.finishAutocompleteSelection('institutionAutocomplete', this.institution)
        },
        selectWorkTicket (ids) {
            const added = ids.some(id => !this.data.work_ticket.some(selected => String(selected) === String(id)))
            this.data.work_ticket = ids
            if (added) this.finishAutocompleteSelection('workTicketAutocomplete', this.country)
        },
        finishAutocompleteSelection (ref, state) {
            state.search = ''
            this.$nextTick(() => {
                const autocomplete = this.$refs[ref]
                if (autocomplete) {
                    autocomplete.internalSearch = null
                    autocomplete.isMenuActive = false
                }
            })
        },
        removeSpecializationById (id) {
            const item = this.specialization.data.find(item => item.id === id)
            if (item) this.removeSpecialization(item)
        },

        showSearchError (error) {
            const response = error && error.response
            this.searchError = response && response.status === 409 && response.data && response.data.message
                ? response.data.message
                : 'Не удалось выполнить запрос к HeadHunter. Повторите попытку позже.'
        },

        searchResume () {
            this.progress = true
            this.searchError = ''
            Object.keys(this.errors).forEach(field => { this.errors[field] = [] })

            return this.$axios.post('/console/search/resume', this.data)
                .then(res => {
                    if (res.data.success) {
                        this.resume = res.data.data.data
                        this.hide = true
                        this.pages = res.data.data.meta.pages
                        this.warning = false
                        this.progress = false
                        window.scrollTo(0, 0);
                    } else {
                        this.errors = {...this.errors, ...res.data.errors}
                        this.warning = ['query', 'query1', 'query2', 'query3'].some(field =>
                            (res.data.errors[field] || []).includes('url'))
                        if (this.warning) window.scrollTo(0, 0)
                    }
                    this.progress = false
                })
                .catch(error => {
                    this.progress = false
                    this.showSearchError(error)
                    window.scrollTo(0, 0)
                })
        },

        searchCountry () {
            this.country.loading = true
            this.country.error = ''
            return this.$axios.post('/console/search/country').then(res => {
                if (!res.data.success) throw new Error('countries')
                this.country.data = res.data.data
            }).catch(() => { this.country.error = 'Не удалось загрузить список стран.' })
                .finally(() => { this.country.loading = false })
        },

        searchMetro () {
            this.$axios.post('/console/search/metro')
                .then(res => {
                    if (res.data.success) {
                        this.metro = res.data.data
                    }
                })
        },

        searchOptions () {
            this.$axios.post('/console/search/options')
                .then(res => {
                    if (res.data.success) {
                        this.options.data = res.data.data
                        this.options.data.hide = this.$store.getters.user.resumeHideViewed
                        this.options.show = false
                    }
                })
        },

        searchSpecialization () {
            this.specialization.loading = true
            this.specialization.error = ''
            this.$axios.post('/console/search/specialization')
                .then(res => {
                    if (res.data.success) {
                        this.specialization.data = res.data.data
                    } else {
                        this.specialization.error = 'Не удалось загрузить список профессий. Повторите попытку.'
                    }
                })
                .catch(() => {
                    this.specialization.error = 'Не удалось загрузить список профессий. Повторите попытку.'
                })
                .finally(() => { this.specialization.loading = false })
        },

        searchWorld () {
            this.world.loading = true
            this.world.error = ''
            this.$axios.post('/console/search/areas')
                .then(res => {
                    if (res.data.success) {
                        this.world.data = res.data.data
                    } else {
                        this.world.error = 'Не удалось загрузить список регионов. Повторите попытку.'
                    }
                })
                .catch(() => {
                    this.world.error = 'Не удалось загрузить список регионов. Повторите попытку.'
                })
                .finally(() => { this.world.loading = false })
        },

        addCitizenship (hh_id) {
            this.data.citizenship.push(hh_id)
            this.$nextTick(() => {
                this.temp.citizenship = ''
            })
        },

        addMetro (hh_id) {
            if (this.data.metro.includes(hh_id)) {
                return
            }

            const metro = this.metro.filter(m => {return m.hh_id === hh_id})[0]

            if (metro.type === 'line') {
                this.metro.forEach(item => {
                    if (item.type === 'station' && this.data.metro.includes(item.hh_id) && item.line_id === metro.id) {
                        this.data.metro.splice(this.data.metro.indexOf(item.hh_id), 1)
                    }
                })
            } else {
                const line = this.metro.filter(m => {return m.id === metro.line_id})[0]
                if (this.data.metro.includes(line.hh_id)) {
                    return
                }
            }

            this.data.metro.push(hh_id)

            this.$nextTick(() => {
                this.temp.metro = ''
            })
        },

        addWorkTicket (hh_id) {
            this.data.work_ticket.push(hh_id)
            this.$nextTick(() => {
                this.temp.work_ticket = ''
            })
        },

        saveWorld (selection) {
            const areas = [...new Set(selection)]
            if (areas.length !== this.data.areas.length || areas.some(id => !this.data.areas.includes(id))) {
                this.data.metro = []
            }
            this.data.areas = areas
        },

        showWorldPopup () {
            this.world.show = true
            if (this.world.error) this.searchWorld()
        },

        removeSkill (item) {
            this.data.skill.splice(this.data.skill.indexOf(item), 1)
            this.data.skill = [...this.data.skill]
        },

        removeSpecialization (specialization) {
            this.data.specialization = this.data.specialization.filter(s => s !== specialization.id)
            if (specialization.parent_id === null) {
                this.specialization.data.forEach(spec => {
                    if (spec.parent_id === specialization.id) {
                        this.data.specialization = this.data.specialization.filter(s => s !== spec.id)
                    }
                })
            } else {
                this.data.specialization = this.data.specialization.filter(s => s !== specialization.parent_id)
            }
        },

        removeCitizenship (country) {
            this.data.citizenship = this.data.citizenship.filter(c => c !== country.hh_id)
        },

        removeMetro (metro) {
            this.data.metro = this.data.metro.filter(m => m !== metro.hh_id)
        },

        removeWorkTicket (country) {
            this.data.work_ticket = this.data.work_ticket.filter(c => c !== country.hh_id)
        },

        removeWorld (world) {
            this.data.metro = []
            this.data.areas = this.data.areas.filter(w => w !== world.id)
        },

        showSpecializationPopup () {
            this.specialization.show = true
            if (this.specialization.error) {
                this.searchSpecialization()
            }
        },

        updateSearchOptions () {
            this.options.progress = true
            this.$store.commit('updateUserResumeHideViewed', this.options.data.hide)

            this.$axios.post('/console/search/options/update', this.options.data)
                .then(res => {
                    if (res.data.success) {
                        this.options.show = false
                        this.options.progress = false
                    }
                })
        },
    },
}
</script>

<style>
.institution-suggestion .v-list-item__title,
.institution-suggestion .v-list-item__subtitle { white-space: normal; overflow-wrap: anywhere; }
.resume-period-buttons.v-btn-toggle { flex-wrap: wrap; max-width: 100%; }
.resume-period-buttons .v-btn { flex: 0 0 auto; }
.save-autosearch-link.v-btn {
    max-width: calc(100% - 36px);
    height: auto;
    min-height: 36px;
    font-size: 14px;
    letter-spacing: normal;
}

.save-autosearch-link .v-btn__content {
    white-space: normal;
    text-align: left;
}

.v-list-item--dense, .v-list--dense .v-list-item {
    min-height: 20px;
}

.v-card--disabled > *:not(.v-card__progress) {
    opacity: 0.3;
}
</style>
